import { AbbrevProvince } from '../graphql/forms/CanadaProvinceResolver';
import { Province } from '../graphql/forms/CanadaProvinceResolver';
import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AbbrevCanadaProvince: { input: AbbrevProvince; output: AbbrevProvince; }
  Answers: { input: Record<string, unknown>; output: Record<string, unknown>; }
  CanadaProvince: { input: Province; output: Province; }
  CanadaTimeZone: { input: string; output: string; }
  ConvertedAnswers: { input: any; output: any; }
  Date: { input: string; output: string; }
  DateTime: { input: string; output: string; }
  JSONObject: { input: Record<string, unknown>; output: Record<string, unknown>; }
  NonNegativeFloat: { input: number; output: number; }
  NonNegativeInt: { input: number; output: number; }
  ObjectID: { input: string; output: string; }
  PostalCode: { input: string; output: string; }
  URL: { input: string; output: string; }
  UUID: { input: string; output: string; }
};

export type AdditionalInsured = {
  address?: InputMaybe<AdditionalInsuredAddress>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type AdditionalInsuredAddress = {
  address2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  postalCode: Scalars['PostalCode']['input'];
  province: Scalars['String']['input'];
  street: Scalars['String']['input'];
};

/**
 * A per-application slice of additional-insured rows. The mutation accepts an
 * array of these so multi-LOB application groups (e.g. GL + EO) can carry
 * independent additional insured info for each product.
 */
export type AdditionalInsuredInfoListForApplication = {
  additionalInsuredInfoList?: InputMaybe<Array<AdditionalInsured>>;
  applicationId: Scalars['ObjectID']['input'];
};

export type Address = {
  __typename?: 'Address';
  city: Scalars['String']['output'];
  postalCode: Scalars['PostalCode']['output'];
  region: Scalars['CanadaProvince']['output'];
  street: Scalars['String']['output'];
};

export type AddressInput = {
  city: Scalars['String']['input'];
  postalCode: Scalars['PostalCode']['input'];
  region: Scalars['CanadaProvince']['input'];
  street: Scalars['String']['input'];
};

export type AnswersInput = {
  answers: Scalars['Answers']['input'];
  applicationId: Scalars['ObjectID']['input'];
  reasonFlag?: InputMaybe<Scalars['String']['input']>;
};

export type AnswersWithIdInput = {
  answers: Scalars['Answers']['input'];
  applicationId: Scalars['ObjectID']['input'];
  isBrokerFlow: Scalars['Boolean']['input'];
  reasonFlag?: InputMaybe<Scalars['String']['input']>;
};

export type ApplicantAddress = {
  __typename?: 'ApplicantAddress';
  address2?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  province: Scalars['String']['output'];
  street: Scalars['String']['output'];
};

export type ApplicationBlocked = {
  __typename?: 'ApplicationBlocked';
  applicationId: Scalars['ObjectID']['output'];
};

export type ApplicationData = {
  __typename?: 'ApplicationData';
  cancellationReason?: Maybe<Scalars['String']['output']>;
  cancellationTrigger?: Maybe<Scalars['String']['output']>;
  carrierPartners?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  country: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  firstJsonFileName: Scalars['String']['output'];
  jsonFileName: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  otherProfessionsLabels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  policyFoxdenId?: Maybe<Scalars['String']['output']>;
  policyObjectId?: Maybe<Scalars['ObjectID']['output']>;
  primaryProfessionLabel: Scalars['String']['output'];
  province?: Maybe<Scalars['String']['output']>;
  secondaryProfessionsLabels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  state?: Maybe<Scalars['String']['output']>;
  transactionType?: Maybe<Scalars['String']['output']>;
  underwritingVersion: Scalars['String']['output'];
};

/**
 * The Configuration flags behind the quote page's per-LOB "Edit" button — the
 * control that sends a customer back into underwriting to change their
 * application answers.
 *
 * Presentation switches only: they hide the entry point, they do not stop a
 * customer who already holds an application URL from editing, so no
 * server-side guard keys off them.
 */
export type ApplicationEditConfiguration = {
  __typename?: 'ApplicationEditConfiguration';
  /**
   * Whether Edit exists in this environment at all
   * (Configuration.enableApplicationEdit, NCP-5437). Defaults to false when the
   * flag is absent, so the capability is off until an environment deliberately
   * turns it on.
   */
  enableApplicationEdit: Scalars['Boolean']['output'];
  /**
   * Whether Edit is shown to internal (Foxquilt) brokers only (true) or to
   * everyone (false) (Configuration.restrictApplicationEditToInternal,
   * NCP-5642). Defaults to true when the flag is absent, so Edit stays
   * restricted until an environment deliberately opens it up. Only meaningful
   * while `enableApplicationEdit` is true. The frontend learns whether the
   * viewer is internal from the auth service's /me.
   */
  restrictApplicationEditToInternal: Scalars['Boolean']['output'];
};

export type ApplicationFailure = {
  __typename?: 'ApplicationFailure';
  error: Scalars['String']['output'];
};

/**
 * Whether an application group can still be modified. Mirrors the
 * assertApplicationNotFinalized guard the quote-page mutations
 * (updateCoverage, updateApplicationAnswersAndQuote, updateEffectiveDate)
 * enforce, exposed as a read-only pre-check so the frontend can block a
 * navigation that has no mutation to fail on — e.g. the "Edit" button, which
 * sends the applicant back into the application.
 */
export type ApplicationFinalizedState = {
  __typename?: 'ApplicationFinalizedState';
  /** True when the group may no longer be modified (signed and/or paid). */
  isFinalized: Scalars['Boolean']['output'];
  /** True once a Policy exists for any application in the group, i.e. it was paid. */
  isPaid: Scalars['Boolean']['output'];
  /** True once the group's T&C envelope has been signed. */
  isSigned: Scalars['Boolean']['output'];
  /** Customer-facing explanation. Null while editable. */
  message?: Maybe<Scalars['String']['output']>;
  /** Which state finalized it: 'paid' or 'signed'. Null while editable. */
  reason?: Maybe<Scalars['String']['output']>;
};

export type ApplicationGroup = {
  __typename?: 'ApplicationGroup';
  /**
   * LOBs that were offered in underwriting but are not currently active
   * members of the group — i.e. selectable "add this coverage" options on the
   * quote page. Computed as: LOBs whose coverage key is present in the entry
   * application's latest ApplicationAnswers (offered, even if unselected) plus
   * LOBs recorded in ApplicationGroupAudit (previously created, e.g. deselected
   * on the quote page), minus the LOBs already active in "applications".
   */
  addableLobs: Array<Scalars['String']['output']>;
  applicationGroupId: Scalars['ObjectID']['output'];
  applications: Array<ApplicationInGroup>;
  /**
   * Whether the group has ever been submitted: a quote exists. A page landing
   * with no walk open uses it to send the customer to the quote page, or back
   * to the start for an application that was never submitted.
   */
  hasSubmission: Scalars['Boolean']['output'];
  /**
   * The walk open on this group, if any. Its queue, not "applications", is
   * what Phase 3 walks: a LOB the walk adds or removes changes "applications"
   * only when the walk is submitted.
   */
  openEdit?: Maybe<OpenEdit>;
};

export type ApplicationInGroup = {
  __typename?: 'ApplicationInGroup';
  applicationId: Scalars['ObjectID']['output'];
  lobType: Scalars['String']['output'];
};

export type ApplicationOwnerData = {
  __typename?: 'ApplicationOwnerData';
  applicationId: Scalars['ObjectID']['output'];
  auth0Identity: Scalars['String']['output'];
  authenticatedAgentEmail?: Maybe<Scalars['String']['output']>;
  authenticatedEmail: Scalars['String']['output'];
  carrierPartner?: Maybe<Scalars['String']['output']>;
  docuSignEnvelopeId?: Maybe<Scalars['String']['output']>;
  isDocuSignEnvelopeSigned: Scalars['Boolean']['output'];
  isTnCLinkSent?: Maybe<Scalars['Boolean']['output']>;
};

export type ApplicationResponse = ApplicationFailure | ApplicationSuccess;

export enum ApplicationResultKind {
  /** This means to decline quote */
  DeclineBusiness = 'DeclineBusiness',
  /** This means error happen */
  Error = 'Error',
  /** This means forward to get a quote */
  OfferQuote = 'OfferQuote',
  /** This means go to broker flow anyway */
  SendToBroker = 'SendToBroker'
}

export type ApplicationSuccess = {
  __typename?: 'ApplicationSuccess';
  applicationId: Scalars['ObjectID']['output'];
  /**
   * Edit Identity: the walk this application opened. Set by createApplication
   * only; the frontend sends it back with every walk mutation.
   */
  editId?: Maybe<Scalars['ObjectID']['output']>;
};

export type BriefInvoiceData = {
  __typename?: 'BriefInvoiceData';
  _id: Scalars['ObjectID']['output'];
};

export type BriefPolicyData = {
  __typename?: 'BriefPolicyData';
  invoice: Invoice;
  kind: Scalars['String']['output'];
};

export type BriefQuoteData = {
  __typename?: 'BriefQuoteData';
  _id: Scalars['ObjectID']['output'];
};

export type BrokerInfo = {
  __typename?: 'BrokerInfo';
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type BusinessAddressChange = {
  __typename?: 'BusinessAddressChange';
  newAddress: UnderwritingAddress;
};

export type BusinessInfo = {
  __typename?: 'BusinessInfo';
  companyName: Scalars['String']['output'];
  coverageStartDate: Scalars['String']['output'];
  customerName: Scalars['String']['output'];
  dbaName?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  locationAddress?: Maybe<ApplicantAddress>;
  mailingAddress?: Maybe<ApplicantAddress>;
  phoneNumber: Scalars['String']['output'];
};

export type CalChangedQuoteResult = {
  __typename?: 'CalChangedQuoteResult';
  changes: Array<EndorsementChange>;
  /**
   * There's only a quote result when changes would introduce change in premiums (i.e. isInvolvePayment).
   * If isInvolvePayment = false then there's no "quote" calculations.
   */
  quote?: Maybe<Scalars['JSONObject']['output']>;
  /** You can get this in the untyped answer set. Use this if/when the answer set is still untyped. */
  startDate: Scalars['Date']['output'];
};

export enum CanadaChildCoverageType {
  /** Commercial General Liability */
  Cgl = 'CGL',
  /** Errors & Omissions */
  Eo = 'EO',
  /** Hardware / Software */
  Hwsw = 'HWSW',
  /** Limited Pollution */
  LimitedPollution = 'LimitedPollution',
  /** Lock Key Business Items */
  LockKeyBusinessItems = 'LockKeyBusinessItems',
  /** Lock Key Contractors */
  LockKeyContractors = 'LockKeyContractors',
  /** Photo Video Endorsement */
  PhotoVideoEndor = 'PhotoVideoEndor',
  /** Physical Loss */
  PhysicalLoss = 'PhysicalLoss',
  /** Unmanned Aircraft */
  UnmannedAircraft = 'UnmannedAircraft',
  /** Unscheduled Business Personal PropertyP */
  UnscheduledBpp = 'UnscheduledBPP',
  /** Unscheduled Contractors */
  UnscheduledContractors = 'UnscheduledContractors',
  /** Unscheduled hardware/software */
  UnscheduledHwsw = 'UnscheduledHWSW',
  /** Unscheduled Small Tools */
  UnscheduledSmallTools = 'UnscheduledSmallTools',
  /** Valuable Papers */
  ValuablePapers = 'ValuablePapers'
}

export type CanadaCoverageLimit = {
  __typename?: 'CanadaCoverageLimit';
  coverage: CanadaCoverageLimitType;
  newLimit?: Maybe<Scalars['NonNegativeFloat']['output']>;
  oldLimit?: Maybe<Scalars['NonNegativeFloat']['output']>;
};

/**
 * This type is mostly a copy of ChildCoverageType. However, it's needed since some child coverage has
 * multiple limits, like E&O which needs to distinguish between occurrence & aggregate limits.
 * Most limit names use the same one as the coverage name since they only have 1 limit.
 */
export enum CanadaCoverageLimitType {
  /** Commercial General Liability */
  Cgl = 'CGL',
  /** Errors & Omissions (Aggregate) */
  EoAggregate = 'EOAggregate',
  /** Errors & Omissions (Occurrence) */
  EoOccurrence = 'EOOccurrence',
  /** Hardware / Software */
  Hwsw = 'HWSW',
  /** Limited Pollution */
  LimitedPollution = 'LimitedPollution',
  /** Lock Key Business Items */
  LockKeyBusinessItems = 'LockKeyBusinessItems',
  /** Lock Key Contractors */
  LockKeyContractors = 'LockKeyContractors',
  /** Photo Video Endorsement */
  PhotoVideoEndor = 'PhotoVideoEndor',
  /** Physical Loss */
  PhysicalLoss = 'PhysicalLoss',
  /** Unmanned Aircraft */
  UnmannedAircraft = 'UnmannedAircraft',
  /** Unscheduled Business Personal PropertyP */
  UnscheduledBpp = 'UnscheduledBPP',
  /** Unscheduled Contractors */
  UnscheduledContractors = 'UnscheduledContractors',
  /** Unscheduled hardware/software */
  UnscheduledHwsw = 'UnscheduledHWSW',
  /** Unscheduled Small Tools */
  UnscheduledSmallTools = 'UnscheduledSmallTools',
  /** Valuable Papers */
  ValuablePapers = 'ValuablePapers'
}

export type CanadaCoverageUpdateChange = {
  __typename?: 'CanadaCoverageUpdateChange';
  action: EndorsementCoverageAction;
  coverage: CanadaParentCoverageType;
  limits: Array<CanadaCoverageLimit>;
};

export enum CanadaParentCoverageType {
  /** Commercial General Liability */
  Cgl = 'CGL',
  /** Inland Marine */
  Im = 'IM'
}

export enum CancellationTrigger {
  Carrier = 'carrier',
  Client = 'client'
}

/** Update CompletedApplicationResponse types in anther ticket */
export type CompletedApplicationResponse = {
  __typename?: 'CompletedApplicationResponse';
  /**
   * The ApplicationGroup that owns this application. The frontend uses this
   * to redirect to the new /quote/:applicationGroupId URL after completing
   * the survey. Always present: every application has a parent
   * ApplicationGroup post-migration, and invalid-applicationId calls throw
   * rather than returning a response.
   */
  applicationGroupId: Scalars['ObjectID']['output'];
  applicationId?: Maybe<Scalars['ObjectID']['output']>;
  /**
   * Edit Identity: true when this completion finished a walk but the quote
   * changed on the quote page while the walk was open, so the walk was not
   * submitted. The frontend explains, then shows the quote page.
   */
  editConflict?: Maybe<Scalars['Boolean']['output']>;
  errors: Array<Scalars['String']['output']>;
  kind: ApplicationResultKind;
};

/** Currencies that are supported by Foxden. */
export enum Currency {
  Cad = 'CAD',
  Usd = 'USD'
}

export type CustomerInfo = {
  __typename?: 'CustomerInfo';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
};

export type CustomerInfoInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type DeclineReason = {
  __typename?: 'DeclineReason';
  declineReason: Scalars['String']['output'];
  questionName: Scalars['String']['output'];
};

export type EndorsementChange = BusinessAddressChange | CanadaCoverageUpdateChange | MailingAddressChange | NamedInsuredChange | OhioCoverageUpdateChange;

export enum EndorsementCoverageAction {
  Add = 'Add',
  Remove = 'Remove',
  Update = 'Update'
}

export type GetJsoNbyApplicationIdResponse = {
  __typename?: 'GetJSONbyApplicationIdResponse';
  carrierPartner: Scalars['String']['output'];
  customerInfo: CustomerInfo;
  displayWcQuestions: Scalars['Boolean']['output'];
  json: Scalars['JSONObject']['output'];
  /**
   * Filename of the JSON returned by this query (Phase 2 / biz_coverage entry-point,
   * or pre-split combined filename for legacy applications). The frontend echoes
   * this back as the `jsonName` arg on updateApplication / completeApplication.
   */
  jsonFileName: Scalars['String']['output'];
  policyExpiryDateStr?: Maybe<Scalars['String']['output']>;
  policyStartDateStr?: Maybe<Scalars['String']['output']>;
  previousAnswers?: Maybe<Scalars['ConvertedAnswers']['output']>;
  professionList: Array<Scalars['String']['output']>;
  /**
   * In-progress biz_coverage answers saved for this application (merged
   * updateApplication docs), used to pre-fill Phase 2 on back-nav from Phase 3.
   */
  savedAnswers?: Maybe<Scalars['ConvertedAnswers']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  transactionType?: Maybe<Scalars['String']['output']>;
  wcData?: Maybe<GetJsonWcResponse>;
};

export type GetJsonWcError = {
  __typename?: 'GetJsonWcError';
  message: Scalars['String']['output'];
};

export type GetJsonWcResponse = GetJsonWcError | GetJsonWcSuccess | GetJsonWcUnavailable;

export type GetJsonWcSuccess = {
  __typename?: 'GetJsonWcSuccess';
  classCodes: Array<WcProfession>;
  isContractor: Scalars['Boolean']['output'];
  rules: Array<Rule>;
};

/** You should expect an empty object with __typename; GraphQL doesn't allow empty object so I need to define something */
export type GetJsonWcUnavailable = {
  __typename?: 'GetJsonWcUnavailable';
  notUsed?: Maybe<Scalars['Boolean']['output']>;
};

export type GetThirdJsonResponse = {
  __typename?: 'GetThirdJsonResponse';
  answersFromSecondJson?: Maybe<Scalars['ConvertedAnswers']['output']>;
  json: Scalars['JSONObject']['output'];
  previousAnswers?: Maybe<Scalars['ConvertedAnswers']['output']>;
  savedAnswers?: Maybe<Scalars['ConvertedAnswers']['output']>;
  /**
   * The Application's transaction type ("New Business" | "Renewal" |
   * "Endorsement" | "Cancellation"). Phase 3 JSON expressions key off it —
   * the E&O retroactive-date default only applies to new business.
   */
  transactionType?: Maybe<Scalars['String']['output']>;
};

export enum IdType {
  Claim = 'Claim',
  Invoice = 'Invoice',
  Policy = 'Policy',
  Quote = 'Quote',
  Transaction = 'Transaction'
}

export type Invoice = {
  __typename?: 'Invoice';
  _id: Scalars['ObjectID']['output'];
};

export type Limit = {
  __typename?: 'Limit';
  industry: Scalars['String']['output'];
  max: Scalars['NonNegativeInt']['output'];
  min: Scalars['NonNegativeInt']['output'];
};

/**
 * State needed to render a Phase 3 LobShell. Returned by getLobShellState
 * for cold-load recovery — i.e. when a user lands on /<applicationId>
 * without router state (refresh after a stale session, pasted URL, link
 * from email, etc.). All fields are derived from Mongo (ApplicationGroup,
 * Application, ApplicationAnswers).
 */
export type LobShellState = {
  __typename?: 'LobShellState';
  /** Carrier partner (e.g. 'Greenlight', 'StateNational'). */
  carrierPartner: Scalars['String']['output'];
  country: Scalars['String']['output'];
  /** Index of the requested applicationId inside lobApplicationIds. */
  currentLobIndex: Scalars['NonNegativeInt']['output'];
  /** The open walk this Phase 3 page belongs to (Edit Identity); null outside one. */
  editId?: Maybe<Scalars['ObjectID']['output']>;
  /** That walk's kind; only 'edit' shows the resubmit banner. */
  editKind?: Maybe<Scalars['String']['output']>;
  /** Phase 3 JSON filenames, one per LOB Application, in group order. */
  fetchThirdJSONs: Array<Scalars['String']['output']>;
  /** ApplicationGroup.data.applicationIds in order. */
  lobApplicationIds: Array<Scalars['ObjectID']['output']>;
  /** First element of Application.data.jsonFileName (the biz_coverage filename). */
  phase2JsonFileName: Scalars['String']['output'];
  /** Last Phase 2 page the current LOB Application's most recent updateApplication stamped. */
  phase2LastPageName: Scalars['String']['output'];
  province: Scalars['String']['output'];
};

export type MailingAddressChange = {
  __typename?: 'MailingAddressChange';
  newAddress: UnderwritingAddress;
};

export type MailingAddressInput = {
  address2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  postalCode: Scalars['PostalCode']['input'];
  province: Scalars['String']['input'];
  street: Scalars['String']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  cancelPolicy: Scalars['String']['output'];
  checkApplicationDateValid: Scalars['Boolean']['output'];
  completeApplication: CompletedApplicationResponse;
  createApplication: ApplicationResponse;
  /**
   * Seed a new LOB Application inside an existing ApplicationGroup. Copies
   * the GL application's Application record + all of its seed
   * ApplicationAnswers rows (createApplication + the updateApplication rows
   * written before Phase 3) onto the new applicationId, overriding lobType
   * (derived from jsonFileName) in the createApplication copy. Also clones
   * the GL PolicyVersion so downstream version-controller lookups by
   * applicationId resolve to the shared workflow/tax version.
   */
  createLobApplication: ApplicationResponse;
  noOp?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Edit Identity: the quote page's Edit button starts an edit. Copies
   * nothing; records the new walk as the open one on the group's
   * ApplicationGroupAudit, replacing any walk open. Refused with
   * APPLICATION_FINALIZED once the group is signed or paid.
   */
  openApplicationEdit: OpenApplicationEditResponse;
  sendQuoteLink: Scalars['Boolean']['output'];
  startWc?: Maybe<Scalars['ObjectID']['output']>;
  updateApplication: UpdateApplicationResponse;
  updateApplicationAnswersAndQuote: UpdateApplicationAnswersAndQuoteResponse;
  updateEffectiveDate: Scalars['Boolean']['output'];
  /**
   * Add or remove a Line of Business from an ApplicationGroup on the quote page.
   *
   * - selected=false: remove the LOB's Application from the group. Its
   *   ApplicationGroupAudit entry is retained so it can be re-added later. At
   *   least one LOB must remain (the request is rejected otherwise).
   * - selected=true: re-add a previously-created LOB from ApplicationGroupAudit
   *   (no redirect if its survey was already completed), or create a fresh
   *   Application and return redirectApplicationId so its survey can be walked.
   */
  updateLob: UpdateLobResult;
};


export type MutationCancelPolicyArgs = {
  quoteId: Scalars['ObjectID']['input'];
};


export type MutationCheckApplicationDateValidArgs = {
  applicationId: Scalars['ObjectID']['input'];
};


export type MutationCompleteApplicationArgs = {
  answersInfo: AnswersWithIdInput;
  editId?: InputMaybe<Scalars['ObjectID']['input']>;
  groupName?: InputMaybe<Scalars['String']['input']>;
  jsonName?: InputMaybe<Scalars['String']['input']>;
  pageName: Scalars['String']['input'];
};


export type MutationCreateApplicationArgs = {
  answersInfo: CreateApplicationAnswersInput;
  cancellationReason?: InputMaybe<Scalars['String']['input']>;
  cancellationTrigger?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  effectiveDateUTC?: InputMaybe<Scalars['String']['input']>;
  groupName?: InputMaybe<Scalars['String']['input']>;
  hubspotTracker?: InputMaybe<Scalars['String']['input']>;
  pageName: Scalars['String']['input'];
  policyFoxdenId?: InputMaybe<Scalars['String']['input']>;
  provinceOrState: Scalars['String']['input'];
  transactionDateUTC?: InputMaybe<Scalars['String']['input']>;
  transactionType: Scalars['String']['input'];
};


export type MutationCreateLobApplicationArgs = {
  applicationGroupId: Scalars['ObjectID']['input'];
  editId?: InputMaybe<Scalars['ObjectID']['input']>;
  jsonFileName: Scalars['String']['input'];
};


export type MutationOpenApplicationEditArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationSendQuoteLinkArgs = {
  applicationId: Scalars['ObjectID']['input'];
  primaryEmail: Scalars['String']['input'];
  secondaryEmails: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationStartWcArgs = {
  applicationObjectId: Scalars['ObjectID']['input'];
  ssn?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateApplicationArgs = {
  agencyBrokerId?: InputMaybe<Scalars['String']['input']>;
  agencyId?: InputMaybe<Scalars['String']['input']>;
  answersInfo: AnswersInput;
  brokerCode?: InputMaybe<Scalars['String']['input']>;
  editId?: InputMaybe<Scalars['ObjectID']['input']>;
  foxquiltAgencyId?: InputMaybe<Scalars['String']['input']>;
  foxquiltBrokerId?: InputMaybe<Scalars['String']['input']>;
  groupName?: InputMaybe<Scalars['String']['input']>;
  hubspotTracker?: InputMaybe<Scalars['String']['input']>;
  jsonName?: InputMaybe<Scalars['String']['input']>;
  lobType?: InputMaybe<Scalars['String']['input']>;
  pageName: Scalars['String']['input'];
  partnercode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateApplicationAnswersAndQuoteArgs = {
  additionalInsuredInfoListByApplicationId?: InputMaybe<Array<AdditionalInsuredInfoListForApplication>>;
  applicationGroupId: Scalars['ObjectID']['input'];
  newCompanyName: Scalars['String']['input'];
  newDBAName?: InputMaybe<Scalars['String']['input']>;
  newEffectiveDate: Scalars['String']['input'];
  newEmail: Scalars['String']['input'];
  newFirstName?: InputMaybe<Scalars['String']['input']>;
  newLastName?: InputMaybe<Scalars['String']['input']>;
  newMailingAddress?: InputMaybe<MailingAddressInput>;
  newPhoneNumber: Scalars['String']['input'];
};


export type MutationUpdateEffectiveDateArgs = {
  applicationGroupId: Scalars['ObjectID']['input'];
  newEffectiveDate: Scalars['String']['input'];
};


export type MutationUpdateLobArgs = {
  applicationGroupId: Scalars['ObjectID']['input'];
  lobType: Scalars['String']['input'];
  selected: Scalars['Boolean']['input'];
};

export type NamedInsuredChange = {
  __typename?: 'NamedInsuredChange';
  namedInsured: Scalars['String']['output'];
};

export type NewQuoteForApplication = {
  __typename?: 'NewQuoteForApplication';
  applicationId: Scalars['ObjectID']['output'];
  lobType: Scalars['String']['output'];
  quoteId: Scalars['ObjectID']['output'];
};

export enum OhioChildCoverageType {
  /** Commercial General Liability */
  Cgl = 'CGL',
  /** Errors & Omissions */
  Eo = 'EO',
  /** Limited Pollution */
  LimitedPollution = 'LimitedPollution',
  /** Terrorism Risk Insurance Act (TRIA) for GL */
  Triagl = 'TRIAGL',
  /** Unmanned Aircraft */
  UnmannedAircraft = 'UnmannedAircraft'
}

export type OhioCoverageLimit = {
  __typename?: 'OhioCoverageLimit';
  coverage: OhioCoverageLimitType;
  newLimit?: Maybe<Scalars['NonNegativeFloat']['output']>;
  oldLimit?: Maybe<Scalars['NonNegativeFloat']['output']>;
};

/**
 * This type is mostly a copy of ChildCoverageType. However, it's needed since some child coverage has
 * multiple limits, like E&O which needs to distinguish between occurrence & aggregate limits.
 * Most limit names use the same one as the coverage name since they only have 1 limit.
 */
export enum OhioCoverageLimitType {
  /** Commercial General Liability (Aggregate) */
  CglAggregate = 'CGLAggregate',
  /** Commercial General Liability (Aggregate) */
  CglOccurrence = 'CGLOccurrence',
  /** Miscellaneous Errors & Omissions (Aggregate) */
  EoAggregate = 'EOAggregate',
  /** Miscellaneous Errors & Omissions (Occurrence) */
  EoOccurrence = 'EOOccurrence',
  /** Limited Pollution (Aggregate) */
  LimitedPollutionAggregate = 'LimitedPollutionAggregate',
  /** Limited Pollution (Occurrence) */
  LimitedPollutionOccurrence = 'LimitedPollutionOccurrence',
  /** Terrorism Risk Insurance Act (TRIA) for GL */
  Triagl = 'TRIAGL',
  /** Unmanned Aircraft */
  UnmannedAircraft = 'UnmannedAircraft'
}

export type OhioCoverageUpdateChange = {
  __typename?: 'OhioCoverageUpdateChange';
  action: EndorsementCoverageAction;
  coverage: OhioParentCoverageType;
  limits: Array<OhioCoverageLimit>;
};

export enum OhioParentCoverageType {
  /** Commercial General Liability */
  Cgl = 'CGL'
}

export type OpenApplicationEditResponse = ApplicationFailure | OpenApplicationEditSuccess;

export type OpenApplicationEditSuccess = {
  __typename?: 'OpenApplicationEditSuccess';
  editId: Scalars['ObjectID']['output'];
  /** 'initial', 'edit' or 'add'. Only 'edit' shows the resubmit banner. */
  kind: Scalars['String']['output'];
};

/**
 * The walk open on an application group (Edit Identity). Present only while a
 * walk is open. The frontend sends editId with every walk mutation; a write
 * carrying any other id is refused as out of date.
 */
export type OpenEdit = {
  __typename?: 'OpenEdit';
  editId: Scalars['ObjectID']['output'];
  /**
   * 'initial' (a new application, endorsement or renewal), 'edit' (the quote
   * page's Edit button) or 'add' (one LOB's survey, added on the quote page).
   */
  kind: Scalars['String']['output'];
  /** Set at the Phase 2 boundary; empty before it. */
  queue: Array<OpenEditQueueEntry>;
};

/** One Phase 3 LOB in an open walk, in walk order (Edit Identity). */
export type OpenEditQueueEntry = {
  __typename?: 'OpenEditQueueEntry';
  /** Null until the Phase 2 boundary has created this LOB's Application. */
  applicationId?: Maybe<Scalars['ObjectID']['output']>;
  /** The Phase 3 survey JSON this LOB is walked with. */
  jsonFileName: Scalars['String']['output'];
  lobType: Scalars['String']['output'];
};

export type PartnerBranding = {
  __typename?: 'PartnerBranding';
  /**
   * Whether the partner has a logo on file. Stays true when logoUrl is null
   * because every surface is switched off.
   */
  hasLogo: Scalars['Boolean']['output'];
  /** Short-lived signed link, or null when there is no logo to show. */
  logoUrl?: Maybe<Scalars['String']['output']>;
  /** The partner code as stored on the agency. */
  partnerCode: Scalars['String']['output'];
  partnerName: Scalars['String']['output'];
  showOnApplication: Scalars['Boolean']['output'];
  showOnQuoteScreen: Scalars['Boolean']['output'];
};

export type PolicyOptionsQueryStringData = {
  __typename?: 'PolicyOptionsQueryStringData';
  cancellationReason?: Maybe<Scalars['String']['output']>;
  cancellationTrigger?: Maybe<Scalars['String']['output']>;
  policyFoxdenId?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  /**
   * Note: we want to calculate the unspent portion of the policy and refund to customers.
   * In other words, the need to calculate for the interval (curExpiryDate, prevExpiryDate);
   * whereas the interval (coverageStartDate, curExpiryDate) is the portion which is spent --
   * coverageStartDate comes from prevAnswers.
   */
  calCancellationQuote: Scalars['JSONObject']['output'];
  /** Use this one to calculate premiums for endorsements. */
  calChangedQuote: CalChangedQuoteResult;
  /** Check if a person or the company they belong to are on the sactions list */
  checkSanctions: SanctionStatus;
  /**
   * Both Edit flags in one O(1) read of the singleton Configuration document.
   * It takes no arguments because the flags are global, so the quote page can
   * read them directly rather than having them threaded down as props.
   */
  getApplicationEditConfiguration: ApplicationEditConfiguration;
  /**
   * Resolve an application group by either an applicationGroupId or a legacy
   * applicationId. The resolver first checks the ApplicationGroup collection;
   * if no match is found, it falls back to the Application collection for
   * back-compatibility with old /quote/:applicationId URLs.
   */
  getApplicationGroup?: Maybe<ApplicationGroup>;
  getApplicationSummary: Scalars['String']['output'];
  getBrokerInfoByQuoteId: BrokerInfo;
  getBusinessInfo: BusinessInfo;
  getFirstJSON: GetFirstJsonResponse;
  getJSONbyApplicationId: GetJsoNbyApplicationIdResponse;
  /**
   * Cold-load recovery for the Phase 3 LobShell. Frontend calls this when
   * location.state is null (refresh after a stale session, pasted URL,
   * etc.). Returns null when the applicationId can't be resolved to a
   * LobShell-ready state (no ApplicationGroup, missing lobType, no
   * Phase 2 updateApplication, etc.) — the frontend redirects in that case.
   */
  getLobShellState?: Maybe<LobShellState>;
  /**
   * Branding for the partner a funnel link names. Resolved from agencyId (the
   * Agency _id a broker link carries) when the link has one, and otherwise from
   * the partner code — the same code the bind path resolves an agency from. Null
   * only when neither names an agency; a partner with no logo, or with every
   * surface switched off, still returns a record so callers can tell those
   * apart.
   *
   * Unauthenticated, like the rest of the funnel: it returns a partner's name
   * and a short-lived link to a marketing asset their own customers are meant
   * to see.
   *
   * Nothing stops two agencies from sharing a code. A link that carries agencyId
   * is unaffected; without it, the result is a record with every surface off —
   * no logo, but not null, so the funnel does not fall back to its built-in
   * list.
   */
  getPartnerBranding?: Maybe<PartnerBranding>;
  /**
   * The same branding, resolved from the partner code and agency id recorded on
   * an application instead of ones supplied by the caller. Takes either an
   * applicationGroupId or a legacy applicationId, like getApplicationGroup.
   *
   * Quote links are emailed without the landing URL's partner code, so the
   * quote screen has no code to pass. Reading it back from the application
   * also keeps the branding out of the caller's hands.
   *
   * Null when the id resolves to nothing, when the application recorded no
   * partner code, or when nothing recorded names an agency.
   */
  getPartnerBrandingForApplication?: Maybe<PartnerBranding>;
  getPolicyOptionsQueryStringData: PolicyOptionsQueryStringData;
  getQuotePageRedirect?: Maybe<QuotePageRedirectView>;
  getThirdJson?: Maybe<GetThirdJsonResponse>;
  /**
   * Whether the EO LOB coverage should be hidden (from Configuration.hideEO,
   * default true). The frontend reads this once and sets it as a SurveyJS
   * variable so the EO Mock question's `visibleIf` hides itself — an O(1)
   * scalar read, no server-side JSON traversal.
   */
  hideEO: Scalars['Boolean']['output'];
  /**
   * Read-only finalization check for a whole application group. Judged across
   * every application in the group (not just the entry one) because a declined
   * LOB has no ApplicationOwner and no Policy and would always look editable.
   */
  isApplicationGroupFinalized: ApplicationFinalizedState;
  /**
   * Whether the EO LOB is launched in the application's state
   * (Configuration.usEOIncludedStates, default false). Independent of the
   * hideEO kill-switch — the frontend combines the two when setting the
   * `hideEO` SurveyJS variable. The state is read server-side from the
   * Application doc.
   */
  isEOStateEnabled: Scalars['Boolean']['output'];
  noOp?: Maybe<Scalars['Boolean']['output']>;
  sendCancellationEmail: Scalars['Boolean']['output'];
  sendEndorsementEmail: Scalars['Boolean']['output'];
  testQuoteEligibility: QuoteFlagResponse;
  tryGetWcQuestions: TryGetWcQuestionsReponse;
};


export type QueryCalCancellationQuoteArgs = {
  curExpiryDate: Scalars['Date']['input'];
  originalStartDate: Scalars['Date']['input'];
  prevAnswers: Scalars['Answers']['input'];
  prevExpiryDate: Scalars['Date']['input'];
  region: Scalars['String']['input'];
};


export type QueryCalChangedQuoteArgs = {
  curAnswers: Scalars['Answers']['input'];
  originalStartDate: Scalars['Date']['input'];
  prevAnswers: Scalars['Answers']['input'];
  prevExpiryDate: Scalars['Date']['input'];
  prevStartDate: Scalars['Date']['input'];
  region: Scalars['String']['input'];
};


export type QueryCheckSanctionsArgs = {
  companyName: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};


export type QueryGetApplicationGroupArgs = {
  id: Scalars['ObjectID']['input'];
  pruneIncompleteLobs?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetApplicationSummaryArgs = {
  applicationId: Scalars['ObjectID']['input'];
};


export type QueryGetBrokerInfoByQuoteIdArgs = {
  quoteId: Scalars['ObjectID']['input'];
};


export type QueryGetBusinessInfoArgs = {
  applicationId: Scalars['ObjectID']['input'];
};


export type QueryGetFirstJsonArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  effectiveDate?: InputMaybe<Scalars['String']['input']>;
  policyFoxdenId?: InputMaybe<Scalars['String']['input']>;
  provinceOrState?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  transactionDate?: InputMaybe<Scalars['String']['input']>;
  transactionType: Scalars['String']['input'];
};


export type QueryGetJsoNbyApplicationIdArgs = {
  applicationId: Scalars['ObjectID']['input'];
};


export type QueryGetLobShellStateArgs = {
  applicationId: Scalars['ObjectID']['input'];
};


export type QueryGetPartnerBrandingArgs = {
  agencyId?: InputMaybe<Scalars['ObjectID']['input']>;
  partnercode: Scalars['String']['input'];
};


export type QueryGetPartnerBrandingForApplicationArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryGetPolicyOptionsQueryStringDataArgs = {
  encryptedData?: InputMaybe<Scalars['String']['input']>;
  ipAddress: Scalars['String']['input'];
};


export type QueryGetQuotePageRedirectArgs = {
  applicationId: Scalars['ObjectID']['input'];
};


export type QueryGetThirdJsonArgs = {
  applicationId: Scalars['ObjectID']['input'];
  thirdJsonFileName: Scalars['String']['input'];
};


export type QueryIsApplicationGroupFinalizedArgs = {
  applicationGroupId: Scalars['ObjectID']['input'];
};


export type QueryIsEoStateEnabledArgs = {
  applicationId: Scalars['ObjectID']['input'];
};


export type QuerySendCancellationEmailArgs = {
  quoteId: Scalars['String']['input'];
};


export type QuerySendEndorsementEmailArgs = {
  quoteId: Scalars['String']['input'];
};


export type QueryTestQuoteEligibilityArgs = {
  answers: Scalars['Answers']['input'];
  country: Scalars['String']['input'];
  jsonFileName: Scalars['String']['input'];
};


export type QueryTryGetWcQuestionsArgs = {
  applicationObjectId: Scalars['ObjectID']['input'];
  wcSessionObjectId: Scalars['ObjectID']['input'];
};

export type QuoteFlagResponse = {
  __typename?: 'QuoteFlagResponse';
  BusinessInformation_Broker: Scalars['Boolean']['output'];
  BusinessInformation_MunichProduct: Scalars['Boolean']['output'];
  Munich_9219_QuoteFlag: Scalars['Boolean']['output'];
  declineQuote: Scalars['Boolean']['output'];
  declineQuoteReason: Scalars['String']['output'];
  declineReasons: Array<DeclineReason>;
};

export type QuotePageRedirectView = {
  __typename?: 'QuotePageRedirectView';
  applicationData: ApplicationData;
  invoice?: Maybe<BriefInvoiceData>;
  /**
   * True when every quoted LOB in the application's group has a Policy.
   * Judged across the whole group (declined LOBs carry no Quote and are
   * excluded), unlike policyData which only reflects THIS application.
   */
  isGroupFullyPaid: Scalars['Boolean']['output'];
  /**
   * True when at least one quoted LOB in the group has a Policy but another
   * quoted LOB does not — the partially paid state: the frontend must send
   * the customer to the payment flow, not the quote screen or complete page.
   */
  isGroupPartiallyPaid: Scalars['Boolean']['output'];
  ownerData?: Maybe<ApplicationOwnerData>;
  policyData?: Maybe<BriefPolicyData>;
  quote?: Maybe<BriefQuoteData>;
};

export type Rule = {
  __typename?: 'Rule';
  canChooseToIncludeExclude: Scalars['Boolean']['output'];
  isIncludedByDefault: Scalars['Boolean']['output'];
  limits: Array<Limit>;
  note: Scalars['String']['output'];
  officer: Scalars['String']['output'];
};

export enum SanctionStatus {
  SanctionFoundForCompany = 'SanctionFoundForCompany',
  SanctionFoundForPerson = 'SanctionFoundForPerson',
  SanctionNotFound = 'SanctionNotFound'
}

export type TryGetWcQuestionsReponse = {
  __typename?: 'TryGetWcQuestionsReponse';
  /** True if the quote cannot be binded by our partners. */
  isDecline: Scalars['Boolean']['output'];
  questions: Array<WcQuestion>;
  /** Client has to keep polling if the status is 'NotFound' */
  status: TryGetWcQuestionsStatus;
};

export enum TryGetWcQuestionsStatus {
  Error = 'Error',
  Found = 'Found',
  NotFound = 'NotFound'
}

export type UnderwritingAddress = {
  __typename?: 'UnderwritingAddress';
  city: Scalars['String']['output'];
  postalCode: Scalars['PostalCode']['output'];
  province: Scalars['AbbrevCanadaProvince']['output'];
  street: Scalars['String']['output'];
};

export type UpdateApplicationAnswersAndQuoteResponse = {
  __typename?: 'UpdateApplicationAnswersAndQuoteResponse';
  isUpdateSuccessful: Scalars['Boolean']['output'];
  newQuoteIds?: Maybe<Array<NewQuoteForApplication>>;
};

export type UpdateApplicationResponse = ApplicationBlocked | ApplicationFailure | ApplicationSuccess;

/**
 * Result of adding or removing a LOB on the quote page (NCP-4545). The frontend
 * refetches getApplicationGroup + getQuote after a successful call, so only the
 * group id and an optional redirect target are returned here.
 */
export type UpdateLobResult = {
  __typename?: 'UpdateLobResult';
  applicationGroupId: Scalars['ObjectID']['output'];
  /**
   * Set when the added LOB still needs its Phase-3 survey completed before it can
   * be quoted — the frontend redirects to /<lobType>/<redirectApplicationId>.
   * Null on deselect, or when a re-added LOB is already quote-ready.
   */
  redirectApplicationId?: Maybe<Scalars['ObjectID']['output']>;
};

/** This is an enum of most of the 2-letter abbreviations of US States. Some states are missing at this time but it's good enough for our purposes. */
export enum UsState {
  Ar = 'AR',
  Az = 'AZ',
  Co = 'CO',
  Ct = 'CT',
  De = 'DE',
  Ga = 'GA',
  Ia = 'IA',
  Id = 'ID',
  Il = 'IL',
  In = 'IN',
  Ks = 'KS',
  Ky = 'KY',
  La = 'LA',
  Md = 'MD',
  Me = 'ME',
  Mi = 'MI',
  Mn = 'MN',
  Mo = 'MO',
  Nc = 'NC',
  Nd = 'ND',
  Ne = 'NE',
  Nh = 'NH',
  Nj = 'NJ',
  Nm = 'NM',
  Oh = 'OH',
  Ok = 'OK',
  Or = 'OR',
  Pa = 'PA',
  Ri = 'RI',
  Sc = 'SC',
  Sd = 'SD',
  Tn = 'TN',
  Ut = 'UT',
  Va = 'VA',
  Vt = 'VT',
  Wi = 'WI',
  Wy = 'WY'
}

export type WcProfession = {
  __typename?: 'WcProfession';
  description: Scalars['String']['output'];
  id: WcProfessionId;
};

export type WcProfessionId = {
  __typename?: 'WcProfessionId';
  classCode: Scalars['String']['output'];
  descriptionCode: Scalars['String']['output'];
};

export type WcProfessionIdInput = {
  classCode: Scalars['String']['input'];
  descriptionCode: Scalars['String']['input'];
};

export type WcQuestion = {
  __typename?: 'WcQuestion';
  id: Scalars['NonNegativeInt']['output'];
  question: Scalars['String']['output'];
};

export type CreateApplicationAnswersInput = {
  BusinessInformation_100_BrokerCode_WORLD_EN?: InputMaybe<Scalars['String']['input']>;
  BusinessInformation_100_Country_WORLD_EN: Scalars['String']['input'];
  BusinessInformation_100_CustomerInfo_WORLD_EN: CustomerInfoInput;
  BusinessInformation_100_EffectiveDate_WORLD_EN?: InputMaybe<Scalars['String']['input']>;
  BusinessInformation_100_OtherProfessionCheck_WORLD_EN?: InputMaybe<Scalars['Boolean']['input']>;
  BusinessInformation_100_PartnerCode_WORLD_EN?: InputMaybe<Scalars['String']['input']>;
  BusinessInformation_100_PrimaryProfession_WORLD_EN: Scalars['String']['input'];
  BusinessInformation_100_ProfessionsPercentage_WORLD_EN?: InputMaybe<Scalars['JSONObject']['input']>;
  BusinessInformation_100_Province_WORLD_EN?: InputMaybe<Scalars['String']['input']>;
  BusinessInformation_100_SecondaryProfessionAdditional_WORLD_EN?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  BusinessInformation_100_SecondaryProfessions_WORLD_EN?: InputMaybe<Array<Scalars['String']['input']>>;
  BusinessInformation_100_State_WORLD_EN?: InputMaybe<Scalars['String']['input']>;
  agencyBrokerId?: InputMaybe<Scalars['String']['input']>;
  agencyId?: InputMaybe<Scalars['String']['input']>;
  foxquiltAgencyId?: InputMaybe<Scalars['String']['input']>;
  foxquiltBrokerId?: InputMaybe<Scalars['String']['input']>;
  otherProfessionsLabels?: InputMaybe<Array<Scalars['String']['input']>>;
  primaryProfessionLabel: Scalars['String']['input'];
  secondaryProfessionsLabels?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GetFirstJsonResponse = {
  __typename?: 'getFirstJSONResponse';
  isStateActive?: Maybe<Scalars['Boolean']['output']>;
  json: Scalars['JSONObject']['output'];
  policyExpiryDateStr?: Maybe<Scalars['String']['output']>;
  policyStartDateStr?: Maybe<Scalars['String']['output']>;
  previousAnswers?: Maybe<Scalars['ConvertedAnswers']['output']>;
};

export type IsEndorsementOrCancellationtResponse = {
  __typename?: 'isEndorsementOrCancellationtResponse';
  isCancellation: Scalars['String']['output'];
  isEndorsement: Scalars['Boolean']['output'];
};

export type CheckApplicationDateValidMutationVariables = Exact<{
  applicationId: Scalars['ObjectID']['input'];
}>;


export type CheckApplicationDateValidMutation = { __typename?: 'Mutation', checkApplicationDateValid: boolean };

export type CompleteApplicationMutationVariables = Exact<{
  answersInfo: AnswersWithIdInput;
  pageName: Scalars['String']['input'];
  groupName?: InputMaybe<Scalars['String']['input']>;
  jsonName?: InputMaybe<Scalars['String']['input']>;
  editId?: InputMaybe<Scalars['ObjectID']['input']>;
}>;


export type CompleteApplicationMutation = { __typename?: 'Mutation', completeApplication: { __typename?: 'CompletedApplicationResponse', applicationId?: string | null, applicationGroupId: string, errors: Array<string>, kind: ApplicationResultKind, editConflict?: boolean | null } };

export type CreateApplicationMutationVariables = Exact<{
  answersInfo: CreateApplicationAnswersInput;
  pageName: Scalars['String']['input'];
  groupName?: InputMaybe<Scalars['String']['input']>;
  hubspotTracker?: InputMaybe<Scalars['String']['input']>;
  policyFoxdenId?: InputMaybe<Scalars['String']['input']>;
  cancellationReason?: InputMaybe<Scalars['String']['input']>;
  cancellationTrigger?: InputMaybe<Scalars['String']['input']>;
  effectiveDateUTC?: InputMaybe<Scalars['String']['input']>;
  transactionDateUTC?: InputMaybe<Scalars['String']['input']>;
  transactionType: Scalars['String']['input'];
  country: Scalars['String']['input'];
  provinceOrState: Scalars['String']['input'];
}>;


export type CreateApplicationMutation = { __typename?: 'Mutation', createApplication: { __typename?: 'ApplicationFailure', error: string } | { __typename?: 'ApplicationSuccess', applicationId: string, editId?: string | null } };

export type CreateLobApplicationMutationVariables = Exact<{
  applicationGroupId: Scalars['ObjectID']['input'];
  jsonFileName: Scalars['String']['input'];
  editId?: InputMaybe<Scalars['ObjectID']['input']>;
}>;


export type CreateLobApplicationMutation = { __typename?: 'Mutation', createLobApplication: { __typename?: 'ApplicationFailure', error: string } | { __typename?: 'ApplicationSuccess', applicationId: string } };

export type GetQuotePageRedirectQueryVariables = Exact<{
  applicationId: Scalars['ObjectID']['input'];
}>;


export type GetQuotePageRedirectQuery = { __typename?: 'Query', getQuotePageRedirect?: { __typename?: 'QuotePageRedirectView', isGroupFullyPaid: boolean, isGroupPartiallyPaid: boolean, ownerData?: { __typename?: 'ApplicationOwnerData', applicationId: string, authenticatedEmail: string, authenticatedAgentEmail?: string | null, isTnCLinkSent?: boolean | null, isDocuSignEnvelopeSigned: boolean } | null, applicationData: { __typename?: 'ApplicationData', policyFoxdenId?: string | null, policyObjectId?: string | null, transactionType?: string | null }, policyData?: { __typename?: 'BriefPolicyData', kind: string, invoice: { __typename?: 'Invoice', _id: string } } | null, quote?: { __typename?: 'BriefQuoteData', _id: string } | null, invoice?: { __typename?: 'BriefInvoiceData', _id: string } | null } | null };

export type GetApplicationEditConfigurationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetApplicationEditConfigurationQuery = { __typename?: 'Query', getApplicationEditConfiguration: { __typename?: 'ApplicationEditConfiguration', enableApplicationEdit: boolean, restrictApplicationEditToInternal: boolean } };

export type GetApplicationGroupQueryVariables = Exact<{
  id: Scalars['ObjectID']['input'];
  pruneIncompleteLobs?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetApplicationGroupQuery = { __typename?: 'Query', getApplicationGroup?: { __typename?: 'ApplicationGroup', applicationGroupId: string, addableLobs: Array<string>, applications: Array<{ __typename?: 'ApplicationInGroup', applicationId: string, lobType: string }> } | null };

export type GetApplicationWalkQueryVariables = Exact<{
  id: Scalars['ObjectID']['input'];
}>;


export type GetApplicationWalkQuery = { __typename?: 'Query', getApplicationGroup?: { __typename?: 'ApplicationGroup', applicationGroupId: string, hasSubmission: boolean, openEdit?: { __typename?: 'OpenEdit', editId: string, kind: string, queue: Array<{ __typename?: 'OpenEditQueueEntry', lobType: string, jsonFileName: string, applicationId?: string | null }> } | null } | null };

export type GetBrokerInfoByQuoteIdQueryVariables = Exact<{
  quoteId: Scalars['ObjectID']['input'];
}>;


export type GetBrokerInfoByQuoteIdQuery = { __typename?: 'Query', getBrokerInfoByQuoteId: { __typename?: 'BrokerInfo', name?: string | null, email?: string | null } };

export type GetBusinessInfoQueryVariables = Exact<{
  applicationId: Scalars['ObjectID']['input'];
}>;


export type GetBusinessInfoQuery = { __typename?: 'Query', getBusinessInfo: { __typename?: 'BusinessInfo', customerName: string, firstName: string, lastName: string, companyName: string, email: string, phoneNumber: string, coverageStartDate: string, dbaName?: string | null, locationAddress?: { __typename?: 'ApplicantAddress', street: string, city: string, province: string, postalCode: string, address2?: string | null } | null, mailingAddress?: { __typename?: 'ApplicantAddress', street: string, city: string, province: string, postalCode: string, address2?: string | null } | null } };

export type GetFirstJsonQueryVariables = Exact<{
  policyFoxdenId?: InputMaybe<Scalars['String']['input']>;
  effectiveDate?: InputMaybe<Scalars['String']['input']>;
  transactionDate?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  transactionType: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  provinceOrState?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetFirstJsonQuery = { __typename?: 'Query', getFirstJSON: { __typename?: 'getFirstJSONResponse', json: Record<string, unknown>, previousAnswers?: any | null, policyStartDateStr?: string | null, policyExpiryDateStr?: string | null, isStateActive?: boolean | null } };

export type GetJsoNbyApplicationIdQueryVariables = Exact<{
  applicationId: Scalars['ObjectID']['input'];
}>;


export type GetJsoNbyApplicationIdQuery = { __typename?: 'Query', getJSONbyApplicationId: { __typename?: 'GetJSONbyApplicationIdResponse', json: Record<string, unknown>, jsonFileName: string, professionList: Array<string>, state?: string | null, previousAnswers?: any | null, savedAnswers?: any | null, policyStartDateStr?: string | null, policyExpiryDateStr?: string | null, transactionType?: string | null, carrierPartner: string, displayWcQuestions: boolean, customerInfo: { __typename?: 'CustomerInfo', firstName: string, lastName: string, email: string, phoneNumber: string }, wcData?: { __typename?: 'GetJsonWcError', message: string } | { __typename?: 'GetJsonWcSuccess', isContractor: boolean, classCodes: Array<{ __typename?: 'WcProfession', description: string, id: { __typename?: 'WcProfessionId', classCode: string, descriptionCode: string } }>, rules: Array<{ __typename?: 'Rule', officer: string, isIncludedByDefault: boolean, canChooseToIncludeExclude: boolean, note: string, limits: Array<{ __typename?: 'Limit', industry: string, min: number, max: number }> }> } | { __typename?: 'GetJsonWcUnavailable' } | null } };

export type GetLobShellStateQueryVariables = Exact<{
  applicationId: Scalars['ObjectID']['input'];
}>;


export type GetLobShellStateQuery = { __typename?: 'Query', getLobShellState?: { __typename?: 'LobShellState', fetchThirdJSONs: Array<string>, carrierPartner: string, phase2LastPageName: string, phase2JsonFileName: string, country: string, province: string, lobApplicationIds: Array<string>, currentLobIndex: number, editId?: string | null, editKind?: string | null } | null };

export type GetPartnerBrandingQueryVariables = Exact<{
  partnercode: Scalars['String']['input'];
  agencyId?: InputMaybe<Scalars['ObjectID']['input']>;
}>;


export type GetPartnerBrandingQuery = { __typename?: 'Query', getPartnerBranding?: { __typename?: 'PartnerBranding', logoUrl?: string | null, hasLogo: boolean, partnerCode: string, partnerName: string, showOnApplication: boolean, showOnQuoteScreen: boolean } | null };

export type GetPartnerBrandingForApplicationQueryVariables = Exact<{
  id: Scalars['ObjectID']['input'];
}>;


export type GetPartnerBrandingForApplicationQuery = { __typename?: 'Query', getPartnerBrandingForApplication?: { __typename?: 'PartnerBranding', logoUrl?: string | null, hasLogo: boolean, partnerCode: string, partnerName: string, showOnApplication: boolean, showOnQuoteScreen: boolean } | null };

export type GetPolicyOptionsQueryStringDataQueryVariables = Exact<{
  ipAddress: Scalars['String']['input'];
  encryptedData?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPolicyOptionsQueryStringDataQuery = { __typename?: 'Query', getPolicyOptionsQueryStringData: { __typename?: 'PolicyOptionsQueryStringData', policyFoxdenId?: string | null, cancellationReason?: string | null, cancellationTrigger?: string | null } };

export type GetThirdJsonQueryVariables = Exact<{
  applicationId: Scalars['ObjectID']['input'];
  thirdJsonFileName: Scalars['String']['input'];
}>;


export type GetThirdJsonQuery = { __typename?: 'Query', getThirdJson?: { __typename?: 'GetThirdJsonResponse', json: Record<string, unknown>, previousAnswers?: any | null, answersFromSecondJson?: any | null, savedAnswers?: any | null, transactionType?: string | null } | null };

export type GetHideEoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHideEoQuery = { __typename?: 'Query', hideEO: boolean };

export type IsApplicationGroupFinalizedQueryVariables = Exact<{
  applicationGroupId: Scalars['ObjectID']['input'];
}>;


export type IsApplicationGroupFinalizedQuery = { __typename?: 'Query', isApplicationGroupFinalized: { __typename?: 'ApplicationFinalizedState', isSigned: boolean, isPaid: boolean, isFinalized: boolean, reason?: string | null, message?: string | null } };

export type GetIsEoStateEnabledQueryVariables = Exact<{
  applicationId: Scalars['ObjectID']['input'];
}>;


export type GetIsEoStateEnabledQuery = { __typename?: 'Query', isEOStateEnabled: boolean };

export type OpenApplicationEditMutationVariables = Exact<{
  id: Scalars['ObjectID']['input'];
}>;


export type OpenApplicationEditMutation = { __typename?: 'Mutation', openApplicationEdit: { __typename?: 'ApplicationFailure', error: string } | { __typename?: 'OpenApplicationEditSuccess', editId: string, kind: string } };


export type SendCancellationEmailQueryVariables = Exact<{
  quoteId: Scalars['String']['input'];
}>;


export type SendCancellationEmailQuery = { __typename?: 'Query', sendCancellationEmail: boolean };

export type SendEndorsementEmailQueryVariables = Exact<{
  quoteId: Scalars['String']['input'];
}>;


export type SendEndorsementEmailQuery = { __typename?: 'Query', sendEndorsementEmail: boolean };

export type SendQuoteLinkMutationVariables = Exact<{
  applicationId: Scalars['ObjectID']['input'];
  secondaryEmails: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  primaryEmail: Scalars['String']['input'];
}>;


export type SendQuoteLinkMutation = { __typename?: 'Mutation', sendQuoteLink: boolean };

export type StartWcMutationVariables = Exact<{
  applicationObjectId: Scalars['ObjectID']['input'];
  ssn?: InputMaybe<Scalars['String']['input']>;
}>;


export type StartWcMutation = { __typename?: 'Mutation', startWc?: string | null };

export type TryGetWcQuestionsQueryVariables = Exact<{
  applicationObjectId: Scalars['ObjectID']['input'];
  wcSessionObjectId: Scalars['ObjectID']['input'];
}>;


export type TryGetWcQuestionsQuery = { __typename?: 'Query', tryGetWcQuestions: { __typename?: 'TryGetWcQuestionsReponse', isDecline: boolean, status: TryGetWcQuestionsStatus, questions: Array<{ __typename?: 'WcQuestion', id: number, question: string }> } };

export type UpdateApplicationMutationVariables = Exact<{
  answersInfo: AnswersInput;
  hubspotTracker?: InputMaybe<Scalars['String']['input']>;
  pageName: Scalars['String']['input'];
  groupName?: InputMaybe<Scalars['String']['input']>;
  foxquiltBrokerId?: InputMaybe<Scalars['String']['input']>;
  foxquiltAgencyId?: InputMaybe<Scalars['String']['input']>;
  brokerCode?: InputMaybe<Scalars['String']['input']>;
  agencyBrokerId?: InputMaybe<Scalars['String']['input']>;
  agencyId?: InputMaybe<Scalars['String']['input']>;
  partnercode?: InputMaybe<Scalars['String']['input']>;
  jsonName?: InputMaybe<Scalars['String']['input']>;
  editId?: InputMaybe<Scalars['ObjectID']['input']>;
}>;


export type UpdateApplicationMutation = { __typename?: 'Mutation', updateApplication: { __typename?: 'ApplicationBlocked' } | { __typename?: 'ApplicationFailure', error: string } | { __typename?: 'ApplicationSuccess', applicationId: string } };

export type UpdateApplicationAnswersAndQuoteMutationVariables = Exact<{
  applicationGroupId: Scalars['ObjectID']['input'];
  newEffectiveDate: Scalars['String']['input'];
  newEmail: Scalars['String']['input'];
  newPhoneNumber: Scalars['String']['input'];
  newCompanyName: Scalars['String']['input'];
  newDBAName?: InputMaybe<Scalars['String']['input']>;
  newFirstName?: InputMaybe<Scalars['String']['input']>;
  newLastName?: InputMaybe<Scalars['String']['input']>;
  newMailingAddress?: InputMaybe<MailingAddressInput>;
  additionalInsuredInfoListByApplicationId?: InputMaybe<Array<AdditionalInsuredInfoListForApplication> | AdditionalInsuredInfoListForApplication>;
}>;


export type UpdateApplicationAnswersAndQuoteMutation = { __typename?: 'Mutation', updateApplicationAnswersAndQuote: { __typename?: 'UpdateApplicationAnswersAndQuoteResponse', isUpdateSuccessful: boolean, newQuoteIds?: Array<{ __typename?: 'NewQuoteForApplication', applicationId: string, quoteId: string, lobType: string }> | null } };

export type UpdateEffectiveDateMutationVariables = Exact<{
  applicationGroupId: Scalars['ObjectID']['input'];
  newEffectiveDate: Scalars['String']['input'];
}>;


export type UpdateEffectiveDateMutation = { __typename?: 'Mutation', updateEffectiveDate: boolean };

export type UpdateLobMutationVariables = Exact<{
  applicationGroupId: Scalars['ObjectID']['input'];
  lobType: Scalars['String']['input'];
  selected: Scalars['Boolean']['input'];
}>;


export type UpdateLobMutation = { __typename?: 'Mutation', updateLob: { __typename?: 'UpdateLobResult', applicationGroupId: string, redirectApplicationId?: string | null } };


export const CheckApplicationDateValidDocument = gql`
    mutation checkApplicationDateValid($applicationId: ObjectID!) {
  checkApplicationDateValid(applicationId: $applicationId)
}
    `;
export type CheckApplicationDateValidMutationFn = ApolloReactCommon.MutationFunction<CheckApplicationDateValidMutation, CheckApplicationDateValidMutationVariables>;

/**
 * __useCheckApplicationDateValidMutation__
 *
 * To run a mutation, you first call `useCheckApplicationDateValidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckApplicationDateValidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkApplicationDateValidMutation, { data, loading, error }] = useCheckApplicationDateValidMutation({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useCheckApplicationDateValidMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CheckApplicationDateValidMutation, CheckApplicationDateValidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CheckApplicationDateValidMutation, CheckApplicationDateValidMutationVariables>(CheckApplicationDateValidDocument, options);
      }
export type CheckApplicationDateValidMutationHookResult = ReturnType<typeof useCheckApplicationDateValidMutation>;
export type CheckApplicationDateValidMutationResult = ApolloReactCommon.MutationResult<CheckApplicationDateValidMutation>;
export type CheckApplicationDateValidMutationOptions = ApolloReactCommon.BaseMutationOptions<CheckApplicationDateValidMutation, CheckApplicationDateValidMutationVariables>;
export const CompleteApplicationDocument = gql`
    mutation completeApplication($answersInfo: AnswersWithIdInput!, $pageName: String!, $groupName: String, $jsonName: String, $editId: ObjectID) {
  completeApplication(
    answersInfo: $answersInfo
    pageName: $pageName
    groupName: $groupName
    jsonName: $jsonName
    editId: $editId
  ) {
    applicationId
    applicationGroupId
    errors
    kind
    editConflict
  }
}
    `;
export type CompleteApplicationMutationFn = ApolloReactCommon.MutationFunction<CompleteApplicationMutation, CompleteApplicationMutationVariables>;

/**
 * __useCompleteApplicationMutation__
 *
 * To run a mutation, you first call `useCompleteApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeApplicationMutation, { data, loading, error }] = useCompleteApplicationMutation({
 *   variables: {
 *      answersInfo: // value for 'answersInfo'
 *      pageName: // value for 'pageName'
 *      groupName: // value for 'groupName'
 *      jsonName: // value for 'jsonName'
 *      editId: // value for 'editId'
 *   },
 * });
 */
export function useCompleteApplicationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CompleteApplicationMutation, CompleteApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CompleteApplicationMutation, CompleteApplicationMutationVariables>(CompleteApplicationDocument, options);
      }
export type CompleteApplicationMutationHookResult = ReturnType<typeof useCompleteApplicationMutation>;
export type CompleteApplicationMutationResult = ApolloReactCommon.MutationResult<CompleteApplicationMutation>;
export type CompleteApplicationMutationOptions = ApolloReactCommon.BaseMutationOptions<CompleteApplicationMutation, CompleteApplicationMutationVariables>;
export const CreateApplicationDocument = gql`
    mutation createApplication($answersInfo: createApplicationAnswersInput!, $pageName: String!, $groupName: String, $hubspotTracker: String, $policyFoxdenId: String, $cancellationReason: String, $cancellationTrigger: String, $effectiveDateUTC: String, $transactionDateUTC: String, $transactionType: String!, $country: String!, $provinceOrState: String!) {
  createApplication(
    answersInfo: $answersInfo
    pageName: $pageName
    groupName: $groupName
    hubspotTracker: $hubspotTracker
    policyFoxdenId: $policyFoxdenId
    cancellationReason: $cancellationReason
    cancellationTrigger: $cancellationTrigger
    effectiveDateUTC: $effectiveDateUTC
    transactionDateUTC: $transactionDateUTC
    transactionType: $transactionType
    country: $country
    provinceOrState: $provinceOrState
  ) {
    ... on ApplicationSuccess {
      applicationId
      editId
    }
    ... on ApplicationFailure {
      error
    }
  }
}
    `;
export type CreateApplicationMutationFn = ApolloReactCommon.MutationFunction<CreateApplicationMutation, CreateApplicationMutationVariables>;

/**
 * __useCreateApplicationMutation__
 *
 * To run a mutation, you first call `useCreateApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApplicationMutation, { data, loading, error }] = useCreateApplicationMutation({
 *   variables: {
 *      answersInfo: // value for 'answersInfo'
 *      pageName: // value for 'pageName'
 *      groupName: // value for 'groupName'
 *      hubspotTracker: // value for 'hubspotTracker'
 *      policyFoxdenId: // value for 'policyFoxdenId'
 *      cancellationReason: // value for 'cancellationReason'
 *      cancellationTrigger: // value for 'cancellationTrigger'
 *      effectiveDateUTC: // value for 'effectiveDateUTC'
 *      transactionDateUTC: // value for 'transactionDateUTC'
 *      transactionType: // value for 'transactionType'
 *      country: // value for 'country'
 *      provinceOrState: // value for 'provinceOrState'
 *   },
 * });
 */
export function useCreateApplicationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateApplicationMutation, CreateApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateApplicationMutation, CreateApplicationMutationVariables>(CreateApplicationDocument, options);
      }
export type CreateApplicationMutationHookResult = ReturnType<typeof useCreateApplicationMutation>;
export type CreateApplicationMutationResult = ApolloReactCommon.MutationResult<CreateApplicationMutation>;
export type CreateApplicationMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateApplicationMutation, CreateApplicationMutationVariables>;
export const CreateLobApplicationDocument = gql`
    mutation createLobApplication($applicationGroupId: ObjectID!, $jsonFileName: String!, $editId: ObjectID) {
  createLobApplication(
    applicationGroupId: $applicationGroupId
    jsonFileName: $jsonFileName
    editId: $editId
  ) {
    ... on ApplicationSuccess {
      applicationId
    }
    ... on ApplicationFailure {
      error
    }
  }
}
    `;
export type CreateLobApplicationMutationFn = ApolloReactCommon.MutationFunction<CreateLobApplicationMutation, CreateLobApplicationMutationVariables>;

/**
 * __useCreateLobApplicationMutation__
 *
 * To run a mutation, you first call `useCreateLobApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLobApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLobApplicationMutation, { data, loading, error }] = useCreateLobApplicationMutation({
 *   variables: {
 *      applicationGroupId: // value for 'applicationGroupId'
 *      jsonFileName: // value for 'jsonFileName'
 *      editId: // value for 'editId'
 *   },
 * });
 */
export function useCreateLobApplicationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateLobApplicationMutation, CreateLobApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateLobApplicationMutation, CreateLobApplicationMutationVariables>(CreateLobApplicationDocument, options);
      }
export type CreateLobApplicationMutationHookResult = ReturnType<typeof useCreateLobApplicationMutation>;
export type CreateLobApplicationMutationResult = ApolloReactCommon.MutationResult<CreateLobApplicationMutation>;
export type CreateLobApplicationMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateLobApplicationMutation, CreateLobApplicationMutationVariables>;
export const GetQuotePageRedirectDocument = gql`
    query getQuotePageRedirect($applicationId: ObjectID!) {
  getQuotePageRedirect(applicationId: $applicationId) {
    ownerData {
      applicationId
      authenticatedEmail
      authenticatedAgentEmail
      isTnCLinkSent
      isDocuSignEnvelopeSigned
    }
    applicationData {
      policyFoxdenId
      policyObjectId
      transactionType
    }
    policyData {
      kind
      invoice {
        _id
      }
    }
    quote {
      _id
    }
    invoice {
      _id
    }
    isGroupFullyPaid
    isGroupPartiallyPaid
  }
}
    `;

/**
 * __useGetQuotePageRedirectQuery__
 *
 * To run a query within a React component, call `useGetQuotePageRedirectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuotePageRedirectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuotePageRedirectQuery({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useGetQuotePageRedirectQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetQuotePageRedirectQuery, GetQuotePageRedirectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetQuotePageRedirectQuery, GetQuotePageRedirectQueryVariables>(GetQuotePageRedirectDocument, options);
      }
export function useGetQuotePageRedirectLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetQuotePageRedirectQuery, GetQuotePageRedirectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetQuotePageRedirectQuery, GetQuotePageRedirectQueryVariables>(GetQuotePageRedirectDocument, options);
        }
export type GetQuotePageRedirectQueryHookResult = ReturnType<typeof useGetQuotePageRedirectQuery>;
export type GetQuotePageRedirectLazyQueryHookResult = ReturnType<typeof useGetQuotePageRedirectLazyQuery>;
export type GetQuotePageRedirectQueryResult = ApolloReactCommon.QueryResult<GetQuotePageRedirectQuery, GetQuotePageRedirectQueryVariables>;
export const GetApplicationEditConfigurationDocument = gql`
    query getApplicationEditConfiguration {
  getApplicationEditConfiguration {
    enableApplicationEdit
    restrictApplicationEditToInternal
  }
}
    `;

/**
 * __useGetApplicationEditConfigurationQuery__
 *
 * To run a query within a React component, call `useGetApplicationEditConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApplicationEditConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApplicationEditConfigurationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetApplicationEditConfigurationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetApplicationEditConfigurationQuery, GetApplicationEditConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetApplicationEditConfigurationQuery, GetApplicationEditConfigurationQueryVariables>(GetApplicationEditConfigurationDocument, options);
      }
export function useGetApplicationEditConfigurationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetApplicationEditConfigurationQuery, GetApplicationEditConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetApplicationEditConfigurationQuery, GetApplicationEditConfigurationQueryVariables>(GetApplicationEditConfigurationDocument, options);
        }
export type GetApplicationEditConfigurationQueryHookResult = ReturnType<typeof useGetApplicationEditConfigurationQuery>;
export type GetApplicationEditConfigurationLazyQueryHookResult = ReturnType<typeof useGetApplicationEditConfigurationLazyQuery>;
export type GetApplicationEditConfigurationQueryResult = ApolloReactCommon.QueryResult<GetApplicationEditConfigurationQuery, GetApplicationEditConfigurationQueryVariables>;
export const GetApplicationGroupDocument = gql`
    query getApplicationGroup($id: ObjectID!, $pruneIncompleteLobs: Boolean) {
  getApplicationGroup(id: $id, pruneIncompleteLobs: $pruneIncompleteLobs) {
    applicationGroupId
    applications {
      applicationId
      lobType
    }
    addableLobs
  }
}
    `;

/**
 * __useGetApplicationGroupQuery__
 *
 * To run a query within a React component, call `useGetApplicationGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApplicationGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApplicationGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetApplicationGroupQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetApplicationGroupQuery, GetApplicationGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetApplicationGroupQuery, GetApplicationGroupQueryVariables>(GetApplicationGroupDocument, options);
      }
export function useGetApplicationGroupLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetApplicationGroupQuery, GetApplicationGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetApplicationGroupQuery, GetApplicationGroupQueryVariables>(GetApplicationGroupDocument, options);
        }
export type GetApplicationGroupQueryHookResult = ReturnType<typeof useGetApplicationGroupQuery>;
export type GetApplicationGroupLazyQueryHookResult = ReturnType<typeof useGetApplicationGroupLazyQuery>;
export type GetApplicationGroupQueryResult = ApolloReactCommon.QueryResult<GetApplicationGroupQuery, GetApplicationGroupQueryVariables>;
export const GetApplicationWalkDocument = gql`
    query getApplicationWalk($id: ObjectID!) {
  getApplicationGroup(id: $id) {
    applicationGroupId
    hasSubmission
    openEdit {
      editId
      kind
      queue {
        lobType
        jsonFileName
        applicationId
      }
    }
  }
}
    `;

/**
 * __useGetApplicationWalkQuery__
 *
 * To run a query within a React component, call `useGetApplicationWalkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApplicationWalkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApplicationWalkQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetApplicationWalkQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetApplicationWalkQuery, GetApplicationWalkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetApplicationWalkQuery, GetApplicationWalkQueryVariables>(GetApplicationWalkDocument, options);
      }
export function useGetApplicationWalkLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetApplicationWalkQuery, GetApplicationWalkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetApplicationWalkQuery, GetApplicationWalkQueryVariables>(GetApplicationWalkDocument, options);
        }
export type GetApplicationWalkQueryHookResult = ReturnType<typeof useGetApplicationWalkQuery>;
export type GetApplicationWalkLazyQueryHookResult = ReturnType<typeof useGetApplicationWalkLazyQuery>;
export type GetApplicationWalkQueryResult = ApolloReactCommon.QueryResult<GetApplicationWalkQuery, GetApplicationWalkQueryVariables>;
export const GetBrokerInfoByQuoteIdDocument = gql`
    query getBrokerInfoByQuoteId($quoteId: ObjectID!) {
  getBrokerInfoByQuoteId(quoteId: $quoteId) {
    name
    email
  }
}
    `;

/**
 * __useGetBrokerInfoByQuoteIdQuery__
 *
 * To run a query within a React component, call `useGetBrokerInfoByQuoteIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrokerInfoByQuoteIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrokerInfoByQuoteIdQuery({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *   },
 * });
 */
export function useGetBrokerInfoByQuoteIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetBrokerInfoByQuoteIdQuery, GetBrokerInfoByQuoteIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetBrokerInfoByQuoteIdQuery, GetBrokerInfoByQuoteIdQueryVariables>(GetBrokerInfoByQuoteIdDocument, options);
      }
export function useGetBrokerInfoByQuoteIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBrokerInfoByQuoteIdQuery, GetBrokerInfoByQuoteIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetBrokerInfoByQuoteIdQuery, GetBrokerInfoByQuoteIdQueryVariables>(GetBrokerInfoByQuoteIdDocument, options);
        }
export type GetBrokerInfoByQuoteIdQueryHookResult = ReturnType<typeof useGetBrokerInfoByQuoteIdQuery>;
export type GetBrokerInfoByQuoteIdLazyQueryHookResult = ReturnType<typeof useGetBrokerInfoByQuoteIdLazyQuery>;
export type GetBrokerInfoByQuoteIdQueryResult = ApolloReactCommon.QueryResult<GetBrokerInfoByQuoteIdQuery, GetBrokerInfoByQuoteIdQueryVariables>;
export const GetBusinessInfoDocument = gql`
    query getBusinessInfo($applicationId: ObjectID!) {
  getBusinessInfo(applicationId: $applicationId) {
    customerName
    firstName
    lastName
    companyName
    email
    phoneNumber
    coverageStartDate
    dbaName
    locationAddress {
      street
      city
      province
      postalCode
      address2
    }
    mailingAddress {
      street
      city
      province
      postalCode
      address2
    }
  }
}
    `;

/**
 * __useGetBusinessInfoQuery__
 *
 * To run a query within a React component, call `useGetBusinessInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusinessInfoQuery({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useGetBusinessInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetBusinessInfoQuery, GetBusinessInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetBusinessInfoQuery, GetBusinessInfoQueryVariables>(GetBusinessInfoDocument, options);
      }
export function useGetBusinessInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBusinessInfoQuery, GetBusinessInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetBusinessInfoQuery, GetBusinessInfoQueryVariables>(GetBusinessInfoDocument, options);
        }
export type GetBusinessInfoQueryHookResult = ReturnType<typeof useGetBusinessInfoQuery>;
export type GetBusinessInfoLazyQueryHookResult = ReturnType<typeof useGetBusinessInfoLazyQuery>;
export type GetBusinessInfoQueryResult = ApolloReactCommon.QueryResult<GetBusinessInfoQuery, GetBusinessInfoQueryVariables>;
export const GetFirstJsonDocument = gql`
    query getFirstJSON($policyFoxdenId: String, $effectiveDate: String, $transactionDate: String, $timezone: String, $transactionType: String!, $country: String, $provinceOrState: String) {
  getFirstJSON(
    policyFoxdenId: $policyFoxdenId
    effectiveDate: $effectiveDate
    transactionDate: $transactionDate
    timezone: $timezone
    transactionType: $transactionType
    country: $country
    provinceOrState: $provinceOrState
  ) {
    json
    previousAnswers
    policyStartDateStr
    policyExpiryDateStr
    isStateActive
  }
}
    `;

/**
 * __useGetFirstJsonQuery__
 *
 * To run a query within a React component, call `useGetFirstJsonQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFirstJsonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFirstJsonQuery({
 *   variables: {
 *      policyFoxdenId: // value for 'policyFoxdenId'
 *      effectiveDate: // value for 'effectiveDate'
 *      transactionDate: // value for 'transactionDate'
 *      timezone: // value for 'timezone'
 *      transactionType: // value for 'transactionType'
 *      country: // value for 'country'
 *      provinceOrState: // value for 'provinceOrState'
 *   },
 * });
 */
export function useGetFirstJsonQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetFirstJsonQuery, GetFirstJsonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFirstJsonQuery, GetFirstJsonQueryVariables>(GetFirstJsonDocument, options);
      }
export function useGetFirstJsonLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFirstJsonQuery, GetFirstJsonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFirstJsonQuery, GetFirstJsonQueryVariables>(GetFirstJsonDocument, options);
        }
export type GetFirstJsonQueryHookResult = ReturnType<typeof useGetFirstJsonQuery>;
export type GetFirstJsonLazyQueryHookResult = ReturnType<typeof useGetFirstJsonLazyQuery>;
export type GetFirstJsonQueryResult = ApolloReactCommon.QueryResult<GetFirstJsonQuery, GetFirstJsonQueryVariables>;
export const GetJsoNbyApplicationIdDocument = gql`
    query getJSONbyApplicationId($applicationId: ObjectID!) {
  getJSONbyApplicationId(applicationId: $applicationId) {
    json
    jsonFileName
    professionList
    customerInfo {
      firstName
      lastName
      email
      phoneNumber
    }
    state
    previousAnswers
    savedAnswers
    policyStartDateStr
    policyExpiryDateStr
    wcData {
      ... on GetJsonWcSuccess {
        classCodes {
          id {
            classCode
            descriptionCode
          }
          description
        }
        rules {
          officer
          limits {
            industry
            min
            max
          }
          isIncludedByDefault
          canChooseToIncludeExclude
          note
        }
        isContractor
      }
      ... on GetJsonWcError {
        message
      }
    }
    transactionType
    carrierPartner
    displayWcQuestions
  }
}
    `;

/**
 * __useGetJsoNbyApplicationIdQuery__
 *
 * To run a query within a React component, call `useGetJsoNbyApplicationIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJsoNbyApplicationIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJsoNbyApplicationIdQuery({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useGetJsoNbyApplicationIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetJsoNbyApplicationIdQuery, GetJsoNbyApplicationIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetJsoNbyApplicationIdQuery, GetJsoNbyApplicationIdQueryVariables>(GetJsoNbyApplicationIdDocument, options);
      }
export function useGetJsoNbyApplicationIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetJsoNbyApplicationIdQuery, GetJsoNbyApplicationIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetJsoNbyApplicationIdQuery, GetJsoNbyApplicationIdQueryVariables>(GetJsoNbyApplicationIdDocument, options);
        }
export type GetJsoNbyApplicationIdQueryHookResult = ReturnType<typeof useGetJsoNbyApplicationIdQuery>;
export type GetJsoNbyApplicationIdLazyQueryHookResult = ReturnType<typeof useGetJsoNbyApplicationIdLazyQuery>;
export type GetJsoNbyApplicationIdQueryResult = ApolloReactCommon.QueryResult<GetJsoNbyApplicationIdQuery, GetJsoNbyApplicationIdQueryVariables>;
export const GetLobShellStateDocument = gql`
    query getLobShellState($applicationId: ObjectID!) {
  getLobShellState(applicationId: $applicationId) {
    fetchThirdJSONs
    carrierPartner
    phase2LastPageName
    phase2JsonFileName
    country
    province
    lobApplicationIds
    currentLobIndex
    editId
    editKind
  }
}
    `;

/**
 * __useGetLobShellStateQuery__
 *
 * To run a query within a React component, call `useGetLobShellStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLobShellStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLobShellStateQuery({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useGetLobShellStateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetLobShellStateQuery, GetLobShellStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetLobShellStateQuery, GetLobShellStateQueryVariables>(GetLobShellStateDocument, options);
      }
export function useGetLobShellStateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetLobShellStateQuery, GetLobShellStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetLobShellStateQuery, GetLobShellStateQueryVariables>(GetLobShellStateDocument, options);
        }
export type GetLobShellStateQueryHookResult = ReturnType<typeof useGetLobShellStateQuery>;
export type GetLobShellStateLazyQueryHookResult = ReturnType<typeof useGetLobShellStateLazyQuery>;
export type GetLobShellStateQueryResult = ApolloReactCommon.QueryResult<GetLobShellStateQuery, GetLobShellStateQueryVariables>;
export const GetPartnerBrandingDocument = gql`
    query getPartnerBranding($partnercode: String!, $agencyId: ObjectID) {
  getPartnerBranding(partnercode: $partnercode, agencyId: $agencyId) {
    logoUrl
    hasLogo
    partnerCode
    partnerName
    showOnApplication
    showOnQuoteScreen
  }
}
    `;

/**
 * __useGetPartnerBrandingQuery__
 *
 * To run a query within a React component, call `useGetPartnerBrandingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartnerBrandingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartnerBrandingQuery({
 *   variables: {
 *      partnercode: // value for 'partnercode'
 *      agencyId: // value for 'agencyId'
 *   },
 * });
 */
export function useGetPartnerBrandingQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetPartnerBrandingQuery, GetPartnerBrandingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPartnerBrandingQuery, GetPartnerBrandingQueryVariables>(GetPartnerBrandingDocument, options);
      }
export function useGetPartnerBrandingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPartnerBrandingQuery, GetPartnerBrandingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPartnerBrandingQuery, GetPartnerBrandingQueryVariables>(GetPartnerBrandingDocument, options);
        }
export type GetPartnerBrandingQueryHookResult = ReturnType<typeof useGetPartnerBrandingQuery>;
export type GetPartnerBrandingLazyQueryHookResult = ReturnType<typeof useGetPartnerBrandingLazyQuery>;
export type GetPartnerBrandingQueryResult = ApolloReactCommon.QueryResult<GetPartnerBrandingQuery, GetPartnerBrandingQueryVariables>;
export const GetPartnerBrandingForApplicationDocument = gql`
    query getPartnerBrandingForApplication($id: ObjectID!) {
  getPartnerBrandingForApplication(id: $id) {
    logoUrl
    hasLogo
    partnerCode
    partnerName
    showOnApplication
    showOnQuoteScreen
  }
}
    `;

/**
 * __useGetPartnerBrandingForApplicationQuery__
 *
 * To run a query within a React component, call `useGetPartnerBrandingForApplicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartnerBrandingForApplicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartnerBrandingForApplicationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPartnerBrandingForApplicationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetPartnerBrandingForApplicationQuery, GetPartnerBrandingForApplicationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPartnerBrandingForApplicationQuery, GetPartnerBrandingForApplicationQueryVariables>(GetPartnerBrandingForApplicationDocument, options);
      }
export function useGetPartnerBrandingForApplicationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPartnerBrandingForApplicationQuery, GetPartnerBrandingForApplicationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPartnerBrandingForApplicationQuery, GetPartnerBrandingForApplicationQueryVariables>(GetPartnerBrandingForApplicationDocument, options);
        }
export type GetPartnerBrandingForApplicationQueryHookResult = ReturnType<typeof useGetPartnerBrandingForApplicationQuery>;
export type GetPartnerBrandingForApplicationLazyQueryHookResult = ReturnType<typeof useGetPartnerBrandingForApplicationLazyQuery>;
export type GetPartnerBrandingForApplicationQueryResult = ApolloReactCommon.QueryResult<GetPartnerBrandingForApplicationQuery, GetPartnerBrandingForApplicationQueryVariables>;
export const GetPolicyOptionsQueryStringDataDocument = gql`
    query getPolicyOptionsQueryStringData($ipAddress: String!, $encryptedData: String) {
  getPolicyOptionsQueryStringData(
    ipAddress: $ipAddress
    encryptedData: $encryptedData
  ) {
    policyFoxdenId
    cancellationReason
    cancellationTrigger
  }
}
    `;

/**
 * __useGetPolicyOptionsQueryStringDataQuery__
 *
 * To run a query within a React component, call `useGetPolicyOptionsQueryStringDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPolicyOptionsQueryStringDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPolicyOptionsQueryStringDataQuery({
 *   variables: {
 *      ipAddress: // value for 'ipAddress'
 *      encryptedData: // value for 'encryptedData'
 *   },
 * });
 */
export function useGetPolicyOptionsQueryStringDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetPolicyOptionsQueryStringDataQuery, GetPolicyOptionsQueryStringDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPolicyOptionsQueryStringDataQuery, GetPolicyOptionsQueryStringDataQueryVariables>(GetPolicyOptionsQueryStringDataDocument, options);
      }
export function useGetPolicyOptionsQueryStringDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPolicyOptionsQueryStringDataQuery, GetPolicyOptionsQueryStringDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPolicyOptionsQueryStringDataQuery, GetPolicyOptionsQueryStringDataQueryVariables>(GetPolicyOptionsQueryStringDataDocument, options);
        }
export type GetPolicyOptionsQueryStringDataQueryHookResult = ReturnType<typeof useGetPolicyOptionsQueryStringDataQuery>;
export type GetPolicyOptionsQueryStringDataLazyQueryHookResult = ReturnType<typeof useGetPolicyOptionsQueryStringDataLazyQuery>;
export type GetPolicyOptionsQueryStringDataQueryResult = ApolloReactCommon.QueryResult<GetPolicyOptionsQueryStringDataQuery, GetPolicyOptionsQueryStringDataQueryVariables>;
export const GetThirdJsonDocument = gql`
    query getThirdJson($applicationId: ObjectID!, $thirdJsonFileName: String!) {
  getThirdJson(
    applicationId: $applicationId
    thirdJsonFileName: $thirdJsonFileName
  ) {
    json
    previousAnswers
    answersFromSecondJson
    savedAnswers
    transactionType
  }
}
    `;

/**
 * __useGetThirdJsonQuery__
 *
 * To run a query within a React component, call `useGetThirdJsonQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetThirdJsonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetThirdJsonQuery({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *      thirdJsonFileName: // value for 'thirdJsonFileName'
 *   },
 * });
 */
export function useGetThirdJsonQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetThirdJsonQuery, GetThirdJsonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetThirdJsonQuery, GetThirdJsonQueryVariables>(GetThirdJsonDocument, options);
      }
export function useGetThirdJsonLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetThirdJsonQuery, GetThirdJsonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetThirdJsonQuery, GetThirdJsonQueryVariables>(GetThirdJsonDocument, options);
        }
export type GetThirdJsonQueryHookResult = ReturnType<typeof useGetThirdJsonQuery>;
export type GetThirdJsonLazyQueryHookResult = ReturnType<typeof useGetThirdJsonLazyQuery>;
export type GetThirdJsonQueryResult = ApolloReactCommon.QueryResult<GetThirdJsonQuery, GetThirdJsonQueryVariables>;
export const GetHideEoDocument = gql`
    query getHideEO {
  hideEO
}
    `;

/**
 * __useGetHideEoQuery__
 *
 * To run a query within a React component, call `useGetHideEoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHideEoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHideEoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetHideEoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetHideEoQuery, GetHideEoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetHideEoQuery, GetHideEoQueryVariables>(GetHideEoDocument, options);
      }
export function useGetHideEoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetHideEoQuery, GetHideEoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetHideEoQuery, GetHideEoQueryVariables>(GetHideEoDocument, options);
        }
export type GetHideEoQueryHookResult = ReturnType<typeof useGetHideEoQuery>;
export type GetHideEoLazyQueryHookResult = ReturnType<typeof useGetHideEoLazyQuery>;
export type GetHideEoQueryResult = ApolloReactCommon.QueryResult<GetHideEoQuery, GetHideEoQueryVariables>;
export const IsApplicationGroupFinalizedDocument = gql`
    query isApplicationGroupFinalized($applicationGroupId: ObjectID!) {
  isApplicationGroupFinalized(applicationGroupId: $applicationGroupId) {
    isSigned
    isPaid
    isFinalized
    reason
    message
  }
}
    `;

/**
 * __useIsApplicationGroupFinalizedQuery__
 *
 * To run a query within a React component, call `useIsApplicationGroupFinalizedQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsApplicationGroupFinalizedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsApplicationGroupFinalizedQuery({
 *   variables: {
 *      applicationGroupId: // value for 'applicationGroupId'
 *   },
 * });
 */
export function useIsApplicationGroupFinalizedQuery(baseOptions: ApolloReactHooks.QueryHookOptions<IsApplicationGroupFinalizedQuery, IsApplicationGroupFinalizedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<IsApplicationGroupFinalizedQuery, IsApplicationGroupFinalizedQueryVariables>(IsApplicationGroupFinalizedDocument, options);
      }
export function useIsApplicationGroupFinalizedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IsApplicationGroupFinalizedQuery, IsApplicationGroupFinalizedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<IsApplicationGroupFinalizedQuery, IsApplicationGroupFinalizedQueryVariables>(IsApplicationGroupFinalizedDocument, options);
        }
export type IsApplicationGroupFinalizedQueryHookResult = ReturnType<typeof useIsApplicationGroupFinalizedQuery>;
export type IsApplicationGroupFinalizedLazyQueryHookResult = ReturnType<typeof useIsApplicationGroupFinalizedLazyQuery>;
export type IsApplicationGroupFinalizedQueryResult = ApolloReactCommon.QueryResult<IsApplicationGroupFinalizedQuery, IsApplicationGroupFinalizedQueryVariables>;
export const GetIsEoStateEnabledDocument = gql`
    query getIsEOStateEnabled($applicationId: ObjectID!) {
  isEOStateEnabled(applicationId: $applicationId)
}
    `;

/**
 * __useGetIsEoStateEnabledQuery__
 *
 * To run a query within a React component, call `useGetIsEoStateEnabledQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIsEoStateEnabledQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIsEoStateEnabledQuery({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useGetIsEoStateEnabledQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetIsEoStateEnabledQuery, GetIsEoStateEnabledQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetIsEoStateEnabledQuery, GetIsEoStateEnabledQueryVariables>(GetIsEoStateEnabledDocument, options);
      }
export function useGetIsEoStateEnabledLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetIsEoStateEnabledQuery, GetIsEoStateEnabledQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetIsEoStateEnabledQuery, GetIsEoStateEnabledQueryVariables>(GetIsEoStateEnabledDocument, options);
        }
export type GetIsEoStateEnabledQueryHookResult = ReturnType<typeof useGetIsEoStateEnabledQuery>;
export type GetIsEoStateEnabledLazyQueryHookResult = ReturnType<typeof useGetIsEoStateEnabledLazyQuery>;
export type GetIsEoStateEnabledQueryResult = ApolloReactCommon.QueryResult<GetIsEoStateEnabledQuery, GetIsEoStateEnabledQueryVariables>;
export const OpenApplicationEditDocument = gql`
    mutation openApplicationEdit($id: ObjectID!) {
  openApplicationEdit(id: $id) {
    ... on OpenApplicationEditSuccess {
      editId
      kind
    }
    ... on ApplicationFailure {
      error
    }
  }
}
    `;
export type OpenApplicationEditMutationFn = ApolloReactCommon.MutationFunction<OpenApplicationEditMutation, OpenApplicationEditMutationVariables>;

/**
 * __useOpenApplicationEditMutation__
 *
 * To run a mutation, you first call `useOpenApplicationEditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOpenApplicationEditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [openApplicationEditMutation, { data, loading, error }] = useOpenApplicationEditMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOpenApplicationEditMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<OpenApplicationEditMutation, OpenApplicationEditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<OpenApplicationEditMutation, OpenApplicationEditMutationVariables>(OpenApplicationEditDocument, options);
      }
export type OpenApplicationEditMutationHookResult = ReturnType<typeof useOpenApplicationEditMutation>;
export type OpenApplicationEditMutationResult = ApolloReactCommon.MutationResult<OpenApplicationEditMutation>;
export type OpenApplicationEditMutationOptions = ApolloReactCommon.BaseMutationOptions<OpenApplicationEditMutation, OpenApplicationEditMutationVariables>;
export const SendCancellationEmailDocument = gql`
    query sendCancellationEmail($quoteId: String!) {
  sendCancellationEmail(quoteId: $quoteId)
}
    `;

/**
 * __useSendCancellationEmailQuery__
 *
 * To run a query within a React component, call `useSendCancellationEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useSendCancellationEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSendCancellationEmailQuery({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *   },
 * });
 */
export function useSendCancellationEmailQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SendCancellationEmailQuery, SendCancellationEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SendCancellationEmailQuery, SendCancellationEmailQueryVariables>(SendCancellationEmailDocument, options);
      }
export function useSendCancellationEmailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SendCancellationEmailQuery, SendCancellationEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SendCancellationEmailQuery, SendCancellationEmailQueryVariables>(SendCancellationEmailDocument, options);
        }
export type SendCancellationEmailQueryHookResult = ReturnType<typeof useSendCancellationEmailQuery>;
export type SendCancellationEmailLazyQueryHookResult = ReturnType<typeof useSendCancellationEmailLazyQuery>;
export type SendCancellationEmailQueryResult = ApolloReactCommon.QueryResult<SendCancellationEmailQuery, SendCancellationEmailQueryVariables>;
export const SendEndorsementEmailDocument = gql`
    query sendEndorsementEmail($quoteId: String!) {
  sendEndorsementEmail(quoteId: $quoteId)
}
    `;

/**
 * __useSendEndorsementEmailQuery__
 *
 * To run a query within a React component, call `useSendEndorsementEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useSendEndorsementEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSendEndorsementEmailQuery({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *   },
 * });
 */
export function useSendEndorsementEmailQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SendEndorsementEmailQuery, SendEndorsementEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SendEndorsementEmailQuery, SendEndorsementEmailQueryVariables>(SendEndorsementEmailDocument, options);
      }
export function useSendEndorsementEmailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SendEndorsementEmailQuery, SendEndorsementEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SendEndorsementEmailQuery, SendEndorsementEmailQueryVariables>(SendEndorsementEmailDocument, options);
        }
export type SendEndorsementEmailQueryHookResult = ReturnType<typeof useSendEndorsementEmailQuery>;
export type SendEndorsementEmailLazyQueryHookResult = ReturnType<typeof useSendEndorsementEmailLazyQuery>;
export type SendEndorsementEmailQueryResult = ApolloReactCommon.QueryResult<SendEndorsementEmailQuery, SendEndorsementEmailQueryVariables>;
export const SendQuoteLinkDocument = gql`
    mutation sendQuoteLink($applicationId: ObjectID!, $secondaryEmails: [String]!, $primaryEmail: String!) {
  sendQuoteLink(
    applicationId: $applicationId
    secondaryEmails: $secondaryEmails
    primaryEmail: $primaryEmail
  )
}
    `;
export type SendQuoteLinkMutationFn = ApolloReactCommon.MutationFunction<SendQuoteLinkMutation, SendQuoteLinkMutationVariables>;

/**
 * __useSendQuoteLinkMutation__
 *
 * To run a mutation, you first call `useSendQuoteLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendQuoteLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendQuoteLinkMutation, { data, loading, error }] = useSendQuoteLinkMutation({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *      secondaryEmails: // value for 'secondaryEmails'
 *      primaryEmail: // value for 'primaryEmail'
 *   },
 * });
 */
export function useSendQuoteLinkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendQuoteLinkMutation, SendQuoteLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendQuoteLinkMutation, SendQuoteLinkMutationVariables>(SendQuoteLinkDocument, options);
      }
export type SendQuoteLinkMutationHookResult = ReturnType<typeof useSendQuoteLinkMutation>;
export type SendQuoteLinkMutationResult = ApolloReactCommon.MutationResult<SendQuoteLinkMutation>;
export type SendQuoteLinkMutationOptions = ApolloReactCommon.BaseMutationOptions<SendQuoteLinkMutation, SendQuoteLinkMutationVariables>;
export const StartWcDocument = gql`
    mutation startWc($applicationObjectId: ObjectID!, $ssn: String) {
  startWc(applicationObjectId: $applicationObjectId, ssn: $ssn)
}
    `;
export type StartWcMutationFn = ApolloReactCommon.MutationFunction<StartWcMutation, StartWcMutationVariables>;

/**
 * __useStartWcMutation__
 *
 * To run a mutation, you first call `useStartWcMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartWcMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startWcMutation, { data, loading, error }] = useStartWcMutation({
 *   variables: {
 *      applicationObjectId: // value for 'applicationObjectId'
 *      ssn: // value for 'ssn'
 *   },
 * });
 */
export function useStartWcMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<StartWcMutation, StartWcMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<StartWcMutation, StartWcMutationVariables>(StartWcDocument, options);
      }
export type StartWcMutationHookResult = ReturnType<typeof useStartWcMutation>;
export type StartWcMutationResult = ApolloReactCommon.MutationResult<StartWcMutation>;
export type StartWcMutationOptions = ApolloReactCommon.BaseMutationOptions<StartWcMutation, StartWcMutationVariables>;
export const TryGetWcQuestionsDocument = gql`
    query tryGetWcQuestions($applicationObjectId: ObjectID!, $wcSessionObjectId: ObjectID!) {
  tryGetWcQuestions(
    applicationObjectId: $applicationObjectId
    wcSessionObjectId: $wcSessionObjectId
  ) {
    isDecline
    status
    questions {
      id
      question
    }
  }
}
    `;

/**
 * __useTryGetWcQuestionsQuery__
 *
 * To run a query within a React component, call `useTryGetWcQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTryGetWcQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTryGetWcQuestionsQuery({
 *   variables: {
 *      applicationObjectId: // value for 'applicationObjectId'
 *      wcSessionObjectId: // value for 'wcSessionObjectId'
 *   },
 * });
 */
export function useTryGetWcQuestionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TryGetWcQuestionsQuery, TryGetWcQuestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TryGetWcQuestionsQuery, TryGetWcQuestionsQueryVariables>(TryGetWcQuestionsDocument, options);
      }
export function useTryGetWcQuestionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TryGetWcQuestionsQuery, TryGetWcQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TryGetWcQuestionsQuery, TryGetWcQuestionsQueryVariables>(TryGetWcQuestionsDocument, options);
        }
export type TryGetWcQuestionsQueryHookResult = ReturnType<typeof useTryGetWcQuestionsQuery>;
export type TryGetWcQuestionsLazyQueryHookResult = ReturnType<typeof useTryGetWcQuestionsLazyQuery>;
export type TryGetWcQuestionsQueryResult = ApolloReactCommon.QueryResult<TryGetWcQuestionsQuery, TryGetWcQuestionsQueryVariables>;
export const UpdateApplicationDocument = gql`
    mutation updateApplication($answersInfo: AnswersInput!, $hubspotTracker: String, $pageName: String!, $groupName: String, $foxquiltBrokerId: String, $foxquiltAgencyId: String, $brokerCode: String, $agencyBrokerId: String, $agencyId: String, $partnercode: String, $jsonName: String, $editId: ObjectID) {
  updateApplication(
    answersInfo: $answersInfo
    hubspotTracker: $hubspotTracker
    pageName: $pageName
    foxquiltBrokerId: $foxquiltBrokerId
    foxquiltAgencyId: $foxquiltAgencyId
    brokerCode: $brokerCode
    agencyBrokerId: $agencyBrokerId
    agencyId: $agencyId
    partnercode: $partnercode
    groupName: $groupName
    jsonName: $jsonName
    editId: $editId
  ) {
    ... on ApplicationSuccess {
      applicationId
    }
    ... on ApplicationFailure {
      error
    }
  }
}
    `;
export type UpdateApplicationMutationFn = ApolloReactCommon.MutationFunction<UpdateApplicationMutation, UpdateApplicationMutationVariables>;

/**
 * __useUpdateApplicationMutation__
 *
 * To run a mutation, you first call `useUpdateApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateApplicationMutation, { data, loading, error }] = useUpdateApplicationMutation({
 *   variables: {
 *      answersInfo: // value for 'answersInfo'
 *      hubspotTracker: // value for 'hubspotTracker'
 *      pageName: // value for 'pageName'
 *      groupName: // value for 'groupName'
 *      foxquiltBrokerId: // value for 'foxquiltBrokerId'
 *      foxquiltAgencyId: // value for 'foxquiltAgencyId'
 *      brokerCode: // value for 'brokerCode'
 *      agencyBrokerId: // value for 'agencyBrokerId'
 *      agencyId: // value for 'agencyId'
 *      partnercode: // value for 'partnercode'
 *      jsonName: // value for 'jsonName'
 *      editId: // value for 'editId'
 *   },
 * });
 */
export function useUpdateApplicationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateApplicationMutation, UpdateApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateApplicationMutation, UpdateApplicationMutationVariables>(UpdateApplicationDocument, options);
      }
export type UpdateApplicationMutationHookResult = ReturnType<typeof useUpdateApplicationMutation>;
export type UpdateApplicationMutationResult = ApolloReactCommon.MutationResult<UpdateApplicationMutation>;
export type UpdateApplicationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateApplicationMutation, UpdateApplicationMutationVariables>;
export const UpdateApplicationAnswersAndQuoteDocument = gql`
    mutation updateApplicationAnswersAndQuote($applicationGroupId: ObjectID!, $newEffectiveDate: String!, $newEmail: String!, $newPhoneNumber: String!, $newCompanyName: String!, $newDBAName: String, $newFirstName: String, $newLastName: String, $newMailingAddress: MailingAddressInput, $additionalInsuredInfoListByApplicationId: [AdditionalInsuredInfoListForApplication!]) {
  updateApplicationAnswersAndQuote(
    applicationGroupId: $applicationGroupId
    newEffectiveDate: $newEffectiveDate
    newEmail: $newEmail
    newPhoneNumber: $newPhoneNumber
    newCompanyName: $newCompanyName
    newDBAName: $newDBAName
    newFirstName: $newFirstName
    newLastName: $newLastName
    newMailingAddress: $newMailingAddress
    additionalInsuredInfoListByApplicationId: $additionalInsuredInfoListByApplicationId
  ) {
    isUpdateSuccessful
    newQuoteIds {
      applicationId
      quoteId
      lobType
    }
  }
}
    `;
export type UpdateApplicationAnswersAndQuoteMutationFn = ApolloReactCommon.MutationFunction<UpdateApplicationAnswersAndQuoteMutation, UpdateApplicationAnswersAndQuoteMutationVariables>;

/**
 * __useUpdateApplicationAnswersAndQuoteMutation__
 *
 * To run a mutation, you first call `useUpdateApplicationAnswersAndQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateApplicationAnswersAndQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateApplicationAnswersAndQuoteMutation, { data, loading, error }] = useUpdateApplicationAnswersAndQuoteMutation({
 *   variables: {
 *      applicationGroupId: // value for 'applicationGroupId'
 *      newEffectiveDate: // value for 'newEffectiveDate'
 *      newEmail: // value for 'newEmail'
 *      newPhoneNumber: // value for 'newPhoneNumber'
 *      newCompanyName: // value for 'newCompanyName'
 *      newDBAName: // value for 'newDBAName'
 *      newFirstName: // value for 'newFirstName'
 *      newLastName: // value for 'newLastName'
 *      newMailingAddress: // value for 'newMailingAddress'
 *      additionalInsuredInfoListByApplicationId: // value for 'additionalInsuredInfoListByApplicationId'
 *   },
 * });
 */
export function useUpdateApplicationAnswersAndQuoteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateApplicationAnswersAndQuoteMutation, UpdateApplicationAnswersAndQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateApplicationAnswersAndQuoteMutation, UpdateApplicationAnswersAndQuoteMutationVariables>(UpdateApplicationAnswersAndQuoteDocument, options);
      }
export type UpdateApplicationAnswersAndQuoteMutationHookResult = ReturnType<typeof useUpdateApplicationAnswersAndQuoteMutation>;
export type UpdateApplicationAnswersAndQuoteMutationResult = ApolloReactCommon.MutationResult<UpdateApplicationAnswersAndQuoteMutation>;
export type UpdateApplicationAnswersAndQuoteMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateApplicationAnswersAndQuoteMutation, UpdateApplicationAnswersAndQuoteMutationVariables>;
export const UpdateEffectiveDateDocument = gql`
    mutation updateEffectiveDate($applicationGroupId: ObjectID!, $newEffectiveDate: String!) {
  updateEffectiveDate(
    applicationGroupId: $applicationGroupId
    newEffectiveDate: $newEffectiveDate
  )
}
    `;
export type UpdateEffectiveDateMutationFn = ApolloReactCommon.MutationFunction<UpdateEffectiveDateMutation, UpdateEffectiveDateMutationVariables>;

/**
 * __useUpdateEffectiveDateMutation__
 *
 * To run a mutation, you first call `useUpdateEffectiveDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEffectiveDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEffectiveDateMutation, { data, loading, error }] = useUpdateEffectiveDateMutation({
 *   variables: {
 *      applicationGroupId: // value for 'applicationGroupId'
 *      newEffectiveDate: // value for 'newEffectiveDate'
 *   },
 * });
 */
export function useUpdateEffectiveDateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateEffectiveDateMutation, UpdateEffectiveDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateEffectiveDateMutation, UpdateEffectiveDateMutationVariables>(UpdateEffectiveDateDocument, options);
      }
export type UpdateEffectiveDateMutationHookResult = ReturnType<typeof useUpdateEffectiveDateMutation>;
export type UpdateEffectiveDateMutationResult = ApolloReactCommon.MutationResult<UpdateEffectiveDateMutation>;
export type UpdateEffectiveDateMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateEffectiveDateMutation, UpdateEffectiveDateMutationVariables>;
export const UpdateLobDocument = gql`
    mutation updateLob($applicationGroupId: ObjectID!, $lobType: String!, $selected: Boolean!) {
  updateLob(
    applicationGroupId: $applicationGroupId
    lobType: $lobType
    selected: $selected
  ) {
    applicationGroupId
    redirectApplicationId
  }
}
    `;
export type UpdateLobMutationFn = ApolloReactCommon.MutationFunction<UpdateLobMutation, UpdateLobMutationVariables>;

/**
 * __useUpdateLobMutation__
 *
 * To run a mutation, you first call `useUpdateLobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLobMutation, { data, loading, error }] = useUpdateLobMutation({
 *   variables: {
 *      applicationGroupId: // value for 'applicationGroupId'
 *      lobType: // value for 'lobType'
 *      selected: // value for 'selected'
 *   },
 * });
 */
export function useUpdateLobMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateLobMutation, UpdateLobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateLobMutation, UpdateLobMutationVariables>(UpdateLobDocument, options);
      }
export type UpdateLobMutationHookResult = ReturnType<typeof useUpdateLobMutation>;
export type UpdateLobMutationResult = ApolloReactCommon.MutationResult<UpdateLobMutation>;
export type UpdateLobMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateLobMutation, UpdateLobMutationVariables>;